(function () {
  'use strict';

  /* === Config === */
  // API base URL is injected per-env via the Liquid config (apiBaseUrl).
  var MAX_RENTAL_DAYS = 89;
  // Fallback label when a fetched terms-and-conditions label is missing.
  var TC_DEFAULT_TERMS_LABEL = "I have read and understand the T&Cs";
  // Placeholder shown on the insurance checkbox until _fetchInsurance lands the merchant label
  // and live price (which are deliberately not in the metafield). Mirrors TC_DEFAULT_TERMS_LABEL.
  var TC_DEFAULT_INSURANCE_LABEL = "Add Insurance";
  // Placeholder shown on the read-only deposit notice until _fetchDeposit lands the merchant
  // label and live amount. Mirrors TC_DEFAULT_INSURANCE_LABEL, but there is no checkbox to
  // label - this is the row's own text, patched in place once the fetch resolves.
  var TC_DEFAULT_DEPOSIT_LABEL = "Refundable deposit";
  // Class applied to a theme Add-to-Cart control we've disabled while the T&C gate is
  // unaccepted. Only ever applied to (and removed from) controls WE disabled - see
  // _disableGatedControls / _restoreGatedControls.
  var TC_GATED_CLASS = 'tc-atc-disabled';
  // Scoped selector for the theme's own submit control(s) inside its product form.
  // Generous but scoped to the form so we never touch unrelated page buttons.
  var TC_SUBMIT_SELECTOR = '[type="submit"], [name="add"], button.product-form__submit';
  // Class toggled on the widget's section to hide the accelerated/dynamic checkout (wallet)
  // button. See _updateAcceleratedCheckoutVisibility for why (Rent tab only).
  var TC_HIDE_ACCEL_CLASS = 'tc-hide-accelerated-checkout';
  // Class applied to the theme's own product form to hide its native submit control(s) when the
  // widget's own-button mode is on (buy_button_mode: 'own'). Scoped to the form - never the
  // whole section - so it can only ever hide the theme's Add-to-Cart, never the widget's own
  // type="submit"/unset-type buttons, which live outside the theme form. See _applyNativeButtonHide.
  var TC_HIDE_NATIVE_CLASS = 'tc-hide-native-atc';
  var CAL_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var CAL_WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  // The add-ons form-submit interceptor is bound on document (see _bindEvents), which is never
  // torn down between widget instances. Tracking the currently-bound handler here lets each new
  // instance (e.g. after the theme editor's shopify:section:load re-init) remove the previous
  // one before adding its own, so document never accumulates a stale listener per re-init.
  var activeFormSubmitHandler = null;

  /* === Icons === */
  var ICONS = {
    shield: '<svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M8 1.5L3 3.5v4c0 3.5 2.5 5.5 5 6.5 2.5-1 5-3 5-6.5v-4L8 1.5z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M5.5 8l2 2 3-3.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    truck: '<svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M1 3h9v8H1zM10 6h2.5L14.5 9v2H10V6z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/><circle cx="4" cy="12" r="1.3" stroke="currentColor" stroke-width="1.2"/><circle cx="12" cy="12" r="1.3" stroke="currentColor" stroke-width="1.2"/></svg>',
    refresh: '<svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M2 8a6 6 0 0110.5-4M14 8a6 6 0 01-10.5 4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><path d="M12.5 1v3h-3M3.5 15v-3h3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    box: '<svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M2 5l6-3 6 3v6l-6 3-6-3V5z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M2 5l6 3m0 0l6-3M8 8v6.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
    calendar: '<svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="2" y="3" width="12" height="11" rx="1.2" stroke="currentColor" stroke-width="1.3"/><path d="M2 6h12M5.5 1.5v3M10.5 1.5v3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
    checkCircle: '<svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.3"/><path d="M5.5 8l2 2 3-3.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  };

  /* === Date helpers === */
  function startOfDay(d) { var x = new Date(d); x.setHours(0, 0, 0, 0); return x; }
  function daysBetween(a, b) { return Math.round((startOfDay(b) - startOfDay(a)) / 86400000); }
  function sameDay(a, b) { return a && b && a.getTime() === b.getTime(); }
  function fmtIsoDate(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }
  function fmtDateLabel(d) {
    return d.getDate() + ' ' + CAL_MONTHS[d.getMonth()].slice(0, 3);
  }
  function fmtDateLabelWithYear(d) {
    return fmtDateLabel(d) + ' ' + d.getFullYear();
  }
  function extractNumericId(gidOrId) {
    var s = String(gidOrId);
    var slash = s.lastIndexOf('/');
    return slash >= 0 ? s.slice(slash + 1) : s;
  }

  function icon(name) {
    return '<span class="tc-icon">' + (ICONS[name] || '') + '</span>';
  }

  /* === Utilities === */
  function formatMoney(cents, currency, locale) {
    return new Intl.NumberFormat(locale || 'en-GB', {
      style: 'currency', currency: currency || 'GBP',
    }).format(cents / 100);
  }

  function el(tag, attrs, children) {
    var e = document.createElement(tag);
    if (attrs) {
      Object.entries(attrs).forEach(function (pair) {
        var k = pair[0], v = pair[1];
        if (k === 'className') e.className = v;
        else if (k === 'textContent') e.textContent = v;
        else if (k === 'innerHTML') e.innerHTML = v;
        else if (k.startsWith('on') && typeof v === 'function') e.addEventListener(k.slice(2).toLowerCase(), v);
        else if (k === 'style' && typeof v === 'object') Object.assign(e.style, v);
        else if (v !== null && v !== undefined && v !== false) e.setAttribute(k, v);
      });
    }
    if (children) {
      (Array.isArray(children) ? children : [children]).forEach(function (c) {
        if (c == null) return;
        e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return e;
  }

  /* === Widget === */
  function TCWidget(sectionId) {
    this.sectionId = sectionId;
    this.container = document.getElementById('tc-widget-' + sectionId);
    var configEl = document.getElementById('tc-config-' + sectionId);
    if (!this.container || !configEl) return;

    try { this.config = JSON.parse(configEl.textContent); }
    catch (e) { console.error('[Total Commerce] Config parse error:', e); return; }

    this.state = {
      currentTab: null,
      selectedPlanId: null,
      // Per-plan billing details (billing interval + minimum cycles), keyed by numeric selling
      // plan id. Shopify Liquid doesn't expose a selling plan's billing policy, so we sync it into
      // the totalcommerce.subscription_plans variant metafield and read it from the Liquid config.
      // Rebuilt from the active variant on init and on every variant change.
      sellingPlanDetails: {},
      rentalConstraints: null,
      rentalDates: { start: null, end: null },
      calendarInstance: null,
      rentalRequestInFlight: false,
      // Selling plan prefetch state: we kick off the create call as soon as both
      // dates are picked so clicking Rent navigates instantly. preparedPlan holds
      // the cached result (keyed by start|end so we can detect staleness). If the
      // user changes dates the prefetch is aborted and a new one starts.
      preparedPlan: null,
      preparingPlanKey: null,
      preparePlanAbortCtrl: null,
      // Per-tab T&C acceptance (checkbox ticked state), keyed by tab name. Task 17 reads
      // this (via _updateGateState) to gate Add-to-Cart; this task only persists it.
      termsAccepted: { subscription: false, rental: false },
      // Per-tab insurance selection (checkbox ticked state), keyed by tab name. Unlike
      // termsAccepted this never gates Add-to-Cart - insurance is optional - it only decides
      // whether _buildCartItems adds the insurance line.
      insuranceSelected: { subscription: false, rental: false },
      // Per-tab custom-field answers, keyed by tab -> { <fieldLabel>: <rawInputValue> }. The
      // configured fields themselves come from the variant availability metafield
      // (subscriptionCustomFields / calendarRentalCustomFields); this only holds what the shopper
      // typed. Required-but-empty entries gate Add-to-Cart (see _customFieldsSatisfied); answered
      // entries are captured as visible line-item properties (see _applyCustomFieldProperties).
      customFieldValues: { subscription: {}, rental: {} },
      // Add-ons: fetched once at load from the anonymous brand-referrer endpoint (all three
      // tabs share the same list, since add-ons are not variant-specific). selectedAddOns is
      // keyed by addOnProductId -> { variantId, quantity }; presence of a key means "selected".
      addOns: [],
      selectedAddOns: {},
      // Re-entrancy guard for the multi-line add-on cart add (shared by the Buy/Subscribe form
      // interception and the Rent tab's add-on path): set synchronously before the async
      // /cart/add.js call so a second click/submit before it resolves is a no-op rather than a
      // second POST.
      addOnSubmitInFlight: false,
    };
    this._abortCtrl = new AbortController();
    this.variant = this._findVariant(this.config.selectedVariantId) || this.config.variants[0] || null;
    this.textContent = this.config.textContent || {};
    // Buy-button mode (block setting): 'theme' (default) reuses the theme's own Add-to-Cart button
    // on the Buy/Subscribe tabs; 'own' renders the widget's own button on those tabs and hides the
    // theme's. The Rent tab always uses the widget's own button regardless. Anything unrecognised
    // falls back to 'theme' so a missing/typo'd setting never strands the shopper without a CTA.
    this.buyButtonMode = this.config.buyButtonMode === 'own' ? 'own' : 'theme';
    this.planPrices = {};
    this.refs = {};
    // Cache of fetched T&C content (name/checkboxLabel/bodyHtml), keyed by termsId, so
    // repeated tab switches/modal opens don't refetch. Only genuine successes are cached:
    // a failed fetch resolves with a fallback but never poisons the cache, so a later
    // retry can still succeed.
    this._termsCache = {};
    // Cache of fetched insurance detail (name/storefrontLabel/price/bodyHtml/
    // insuranceVariantInternalId), keyed by insuranceProfileId. Mirrors _termsCache: only
    // genuine successes are cached, a failed (or not-found/disabled) fetch resolves with null
    // but is never cached, so a later retry (e.g. after the merchant re-enables the profile)
    // can still succeed.
    this._insuranceCache = {};
    // The fetched insurance detail currently backing each tab's checkbox, keyed by tab name.
    // Null when that tab has no insurance profile id, or the fetch hasn't resolved (or failed).
    // _buildCartItems reads this alongside state.insuranceSelected to decide whether to add the
    // insurance cart line.
    this._loadedInsurance = { subscription: null, rental: null };
    // Cache of fetched deposit detail (name/storefrontLabel/amount/bodyHtml/
    // depositVariantInternalId), keyed by depositProfileId. Mirrors _insuranceCache: only
    // genuine successes are cached, a failed (or not-found/disabled) fetch resolves with null
    // but is never cached, so a later retry (e.g. the merchant re-enables the profile) can
    // still succeed.
    this._depositCache = {};
    // The fetched deposit detail currently backing each tab's read-only notice, keyed by tab
    // name. Null when that tab has no deposit profile id, or the fetch hasn't resolved (or
    // failed). Unlike _loadedInsurance there is no companion "selected" state on this.state -
    // a deposit has no opt-out - and _depositGateSatisfied reads this directly to gate
    // Add-to-Cart: a configured-but-unloaded deposit blocks the button rather than merely
    // hiding a checkbox.
    this._loadedDeposit = { subscription: null, rental: null };
    // Theme Add-to-Cart control(s) we've personally disabled while the subscribe-tab T&C
    // gate is unaccepted, so _restoreGatedControls only ever re-enables buttons we touched.
    this._gatedButtons = [];
    // Membership mandate config, read from the app embed's #tc-membership-config data element
    // (the same source tc-membership-embed.js uses). Null when memberships are off / the embed
    // isn't enabled - in which case no mandate line is ever injected. Read once at construction.
    this._membershipConfig = this._readMembershipConfig();

    this.state.sellingPlanDetails = this._indexVariantSellingPlanDetails(this.variant);
    this._recalcPlanPrices();
    this._render();
    this._bindEvents();

    this._pickDefaultTab();
    this._updateSoldOut();
    // Belt-and-braces: _pickDefaultTab already runs _switchTab -> _updateGateState for the
    // common case, but if no tab is available at all (canSell/canSubscribe/canRent all
    // false) that never fires, so reconcile explicitly here too.
    this._updateGateState();
    // Seed the accelerated-checkout (wallet) path: mirror the current selection into the theme
    // form as shopify-additional-items hidden inputs so an express purchase carries the same
    // add-ons / insurance / membership-mandate lines a normal cart add would. (_updateGateState
    // above already reconciled the wallet button's visibility.)
    this._syncAdditionalItemsToForm();
    this._fetchAddOns();
    this._logAvailability('init');
  }

  function avail(variant) {
    return variant && variant.availability ? variant.availability : null;
  }

  var W = TCWidget.prototype;

  // Debug helper — logs the tc.availability metafield for the current variant alongside
  // the resulting tab-visibility decisions. Lets you confirm in the browser console that
  // the metafield is being read correctly without needing dev tools to inspect the JSON
  // config element. Safe to leave in: zero behavioural impact, single line per variant change.
  W._logAvailability = function (reason) {
    if (!this.variant) {
      console.log('[Total Commerce] availability (' + reason + '): no variant selected');
      return;
    }
    var canRent = this._canRent();
    var entry = {
      variantId: this.variant.id,
      wuvaVariantId: this.variant.wuvaVariantId,
      availability: this.variant.availability,
      tabs: {
        canSell: this._canSell(),
        canSubscribe: this._canSubscribe(),
        canRent: canRent
      }
    };
    if (!canRent) entry.canRentBlockedBy = this._canRentBlockers();
    console.log('[Total Commerce] availability (' + reason + '):', entry);
  };

  // Enumerates every condition in _canRent that's currently failing. Useful when a
  // merchant expects the Rent tab to show but doesn't — the console line will name
  // exactly which input is missing rather than a single false boolean.
  W._canRentBlockers = function () {
    var blockers = [];
    var a = avail(this.variant);
    if (!a) {
      blockers.push('availability metafield (tc.availability) missing on variant');
    } else if (a.calendarRentalsEnabled !== true) {
      blockers.push('availability.calendarRentalsEnabled !== true (actual: ' + JSON.stringify(a.calendarRentalsEnabled) + ')');
    }
    if (!this.variant || !this.variant.wuvaVariantId) {
      blockers.push('variant.wuvaVariantId missing (wuva.id variant metafield not set / not synced)');
    }
    if (!this.config.clientId) {
      blockers.push('config.clientId missing (wuva.clientId product metafield not set / not synced)');
    }
    if (!this.config.apiBaseUrl) {
      blockers.push('config.apiBaseUrl missing (tc_api_base_url not assigned in tc-purchase-options.liquid)');
    }
    return blockers;
  };

  /* — Variant helpers — */

  W._findVariant = function (id) {
    return this.config.variants.find(function (v) { return v.id == id; }) || null;
  };

  /* — Availability (per-variant `tc.availability` metafield, with safe fallbacks) — */

  // If the metafield is missing (definition not set up or not yet synced),
  // fall back to the legacy product-level config so existing products don't
  // suddenly lose tabs on rollout. Calendar rentals are opt-in only — no fallback.
  W._canSell = function () {
    var a = avail(this.variant);
    if (a) return a.saleEnabled === true;
    return this.config.allowsOneTimePurchase === true;
  };
  W._canSubscribe = function () {
    var a = avail(this.variant);
    if (a) return a.subscriptionEnabled === true && this.config.hasSellingPlans === true;
    return this.config.hasSellingPlans === true;
  };
  W._canRent = function () {
    var a = avail(this.variant);
    return !!(a && a.calendarRentalsEnabled === true && this.variant && this.variant.wuvaVariantId && this.config.clientId && this.config.apiBaseUrl);
  };

  W._pickDefaultTab = function () {
    if (this._canSubscribe()) this._switchTab('subscription');
    else if (this._canSell()) this._switchTab('purchase');
    else if (this._canRent()) this._switchTab('rental');
  };

  // Returns the T&C set id (GUID string) that gates the given tab, or null when that tab (or
  // the current variant) has no terms requirement. Purchase never requires terms. Tab-scoped
  // (rather than reading state.currentTab itself) so _renderTermsGate can evaluate each panel's
  // OWN tab independently of whichever tab happens to be active right now.
  W._termsIdForTab = function (tab) {
    var a = avail(this.variant);
    if (!a) return null;
    if (tab === 'subscription') return a.subscriptionTermsId || null;
    if (tab === 'rental') return a.calendarRentalTermsId || null;
    return null;
  };

  // Returns the T&C set id that gates the currently selected tab. No-arg accessor Task 17
  // reads to decide Add-to-Cart gating; re-evaluated on every tab switch / variant change so a
  // late async resolve (see _renderTermsGate / _openTermsModal) can check "is this still current".
  W._activeTermsId = function () {
    return this._termsIdForTab(this.state.currentTab);
  };

  // Returns the insurance profile id offered alongside the given tab, or null when that tab (or
  // the current variant) has no insurance to offer. Purchase never offers insurance. Mirrors
  // _termsIdForTab exactly, reading the twin field the same availability metafield now carries
  // (see Task 11's plumbing) rather than a separate config key - no new block setting needed.
  W._insuranceIdForTab = function (tab) {
    var a = avail(this.variant);
    if (!a) return null;
    if (tab === 'subscription') return a.subscriptionInsuranceProfileId || null;
    if (tab === 'rental') return a.calendarRentalInsuranceProfileId || null;
    return null;
  };

  // Returns the deposit profile id required alongside the given tab, or null when that tab (or
  // the current variant) has no deposit requirement. Purchase never requires a deposit. Mirrors
  // _insuranceIdForTab exactly, reading the twin field the same availability metafield carries
  // (see Task 13's plumbing). Unlike insurance, a non-null id here is mandatory - see
  // _depositGateSatisfied, which blocks Add-to-Cart until the corresponding fetch resolves.
  W._depositIdForTab = function (tab) {
    var a = avail(this.variant);
    if (!a) return null;
    if (tab === 'subscription') return a.subscriptionDepositProfileId || null;
    if (tab === 'rental') return a.calendarRentalDepositProfileId || null;
    return null;
  };

  // Returns the configured custom fields for the given tab, or [] when none. Mirrors
  // _depositIdForTab: reads the twin arrays the same availability metafield carries
  // (subscriptionCustomFields / calendarRentalCustomFields), each entry { label, type, required }.
  // Purchase never has custom fields (no profile), so returns [].
  W._customFieldsForTab = function (tab) {
    var a = avail(this.variant);
    if (!a) return [];
    var list = tab === 'subscription' ? a.subscriptionCustomFields
      : tab === 'rental' ? a.calendarRentalCustomFields
        : null;
    return Array.isArray(list) ? list : [];
  };

  // Formats a raw input value for display/capture. Date fields (native <input type="date">) arrive
  // as ISO "YYYY-MM-DD"; render them human-readably ("14 June 2026") using the calendar month names,
  // parsed by parts so there is no timezone shift. Text and unparseable values pass through trimmed.
  W._formatCustomFieldValue = function (field, raw) {
    var value = (raw == null ? '' : String(raw)).trim();
    if (!value) return '';
    var isDate = field && field.type && String(field.type).toLowerCase() === 'date';
    if (isDate) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
      if (m) {
        var year = parseInt(m[1], 10);
        var month = parseInt(m[2], 10);
        var day = parseInt(m[3], 10);
        if (month >= 1 && month <= 12) return day + ' ' + CAL_MONTHS[month - 1] + ' ' + year;
      }
    }
    return value;
  };

  // The answered (non-empty) custom fields for a tab, as [{ label, value }] with values formatted.
  // Shared by every capture path (_applyCustomFieldProperties, _navigateToCart, _syncCustomFieldsToForm)
  // so they never diverge on which fields are captured or how a value is rendered.
  W._collectCustomFieldAnswers = function (tab) {
    var self = this;
    var values = this.state.customFieldValues[tab] || {};
    var answers = [];
    this._customFieldsForTab(tab).forEach(function (field) {
      if (!field || !field.label) return;
      var formatted = self._formatCustomFieldValue(field, values[field.label]);
      if (formatted) answers.push({ label: field.label, value: formatted });
    });
    return answers;
  };

  // True when every REQUIRED custom field for the tab has a non-empty value. Optional fields never
  // block. Folded into _isGatePassed so a required-but-empty field disables Add-to-Cart the same way
  // an unaccepted T&C or an unloaded deposit does.
  W._customFieldsSatisfied = function (tab) {
    var values = this.state.customFieldValues[tab] || {};
    return this._customFieldsForTab(tab).every(function (field) {
      if (!field || !field.required) return true;
      var v = values[field.label];
      return v != null && String(v).trim() !== '';
    });
  };

  /**
   * Use per-variant selling_plan_allocations for accurate prices when available,
   * falling back to percentage calculation from the plan's priceAdjustments.
   */
  W._recalcPlanPrices = function () {
    this.planPrices = {};
    if (!this.variant) return;

    var vPrice = this.variant.price;
    var allocs = this.variant.sellingPlanAllocations || [];
    var pp = this.planPrices;

    // Index allocations by selling plan ID for O(1) lookup
    var allocMap = {};
    allocs.forEach(function (a) { allocMap[a.sellingPlanId] = a.perDeliveryPrice; });

    this.config.sellingPlanGroups.forEach(function (group) {
      group.plans.forEach(function (plan) {
        // Prefer allocation price (accurate), fall back to calculated
        if (allocMap[plan.id] !== undefined) {
          pp[plan.id] = allocMap[plan.id];
        } else {
          var adjs = plan.priceAdjustments;
          if (adjs && adjs.length && adjs[0].valueType === 'percentage') {
            pp[plan.id] = Math.round(vPrice * (100 - adjs[0].value) / 100);
          } else {
            pp[plan.id] = vPrice;
          }
        }
      });
    });
  };

  W._allPlans = function () {
    var plans = [];
    this.config.sellingPlanGroups.forEach(function (g) {
      g.plans.forEach(function (p) { plans.push(p); });
    });
    return plans;
  };

  /** Returns plans available to the current variant (has an allocation) */
  W._availablePlans = function () {
    var allocs = this.variant ? (this.variant.sellingPlanAllocations || []) : [];
    if (!allocs.length) return this._allPlans(); // no allocation data = show all (backwards compat)
    var allocIds = {};
    allocs.forEach(function (a) { allocIds[a.sellingPlanId] = true; });
    return this._allPlans().filter(function (p) { return allocIds[p.id]; });
  };

  W._getRevenueModel = function () {
    return this.state.currentTab === 'subscription' ? 'subscription' : 'purchase';
  };

  W._fmt = function (cents) {
    return formatMoney(cents, this.config.shopCurrency, this.config.shopLocale);
  };

  /* — Sold out — */

  W._updateSoldOut = function () {
    var available = this.variant ? this.variant.available : false;
    this.container.dataset.soldOut = available ? 'false' : 'true';
  };

  /* — Render — */

  W._render = function () {
    var frag = document.createDocumentFragment();
    frag.appendChild(this._renderTabs());
    // Panels are always built; visibility is driven by tab gating + _refreshTabVisibility.
    // This avoids re-rendering panels when the user switches variant.
    frag.appendChild(this._renderBuyPanel());
    if (this.config.hasSellingPlans) frag.appendChild(this._renderSubscriptionPanel());
    frag.appendChild(this._renderRentPanel());

    var errEl = el('div', { className: 'tc-error', 'data-visible': 'false' });
    frag.appendChild(errEl);
    this.refs.error = errEl;

    this.container.innerHTML = '';
    this.container.appendChild(frag);

    this._refreshTabVisibility();
  };

  // Reads current variant's availability and shows/hides tabs + panels.
  W._refreshTabVisibility = function () {
    var canSell = this._canSell();
    var canSub = this._canSubscribe();
    var canRent = this._canRent();

    if (this.refs.buyTabBtn) this.refs.buyTabBtn.style.display = canSell ? '' : 'none';
    if (this.refs.subTabBtn) this.refs.subTabBtn.style.display = canSub ? '' : 'none';
    if (this.refs.rentTabBtn) this.refs.rentTabBtn.style.display = canRent ? '' : 'none';

    if (this.refs.buyPanel) this.refs.buyPanel.style.display = canSell ? '' : 'none';
    if (this.refs.subscriptionPanel) this.refs.subscriptionPanel.style.display = canSub ? '' : 'none';
    if (this.refs.rentPanel) this.refs.rentPanel.style.display = canRent ? '' : 'none';

    // The "Or subscribe from £X/mo" nudge in the buy panel only makes sense
    // when the current variant actually allows subscriptions.
    if (this.refs.buyNudge) this.refs.buyNudge.style.display = canSub ? '' : 'none';

    this._updateTabCount();

    // Current tab is now hidden — flip to whichever tab is available.
    var current = this.state.currentTab;
    var currentOk =
      (current === 'purchase' && canSell) ||
      (current === 'subscription' && canSub) ||
      (current === 'rental' && canRent);
    if (!currentOk) this._pickDefaultTab();
  };

  W._renderTabs = function () {
    var self = this;
    var nav = el('div', { className: 'tc-tabs', role: 'tablist', 'data-count': '0' });
    this.refs.tabNav = nav;

    var subBtn = el('button', { type: 'button', className: 'tc-tab-btn', role: 'tab',
      'aria-selected': 'false', 'data-tab': 'subscription', textContent: (self.textContent.tabs && self.textContent.tabs.sellingPlansButton) || 'Subscribe' });
    subBtn.addEventListener('click', function () { self._switchTab('subscription'); });
    nav.appendChild(subBtn);
    this.refs.subTabBtn = subBtn;

    var buyBtn = el('button', { type: 'button', className: 'tc-tab-btn', role: 'tab',
      'aria-selected': 'false', 'data-tab': 'purchase', textContent: (self.textContent.tabs && self.textContent.tabs.saleButton) || 'Buy' });
    buyBtn.addEventListener('click', function () { self._switchTab('purchase'); });
    nav.appendChild(buyBtn);
    this.refs.buyTabBtn = buyBtn;

    var rentBtn = el('button', { type: 'button', className: 'tc-tab-btn', role: 'tab',
      'aria-selected': 'false', 'data-tab': 'rental', textContent: (self.textContent.tabs && self.textContent.tabs.rentalButton) || 'Rent' });
    rentBtn.addEventListener('click', function () { self._switchTab('rental'); });
    nav.appendChild(rentBtn);
    this.refs.rentTabBtn = rentBtn;

    this._updateTabCount();
    return nav;
  };

  W._renderBuyPanel = function () {
    var self = this;
    var panel = el('div', { className: 'tc-panel', 'data-panel': 'purchase', 'data-active': 'false', role: 'tabpanel' });
    var v = this.variant;

    var priceWrap = el('div', { className: 'tc-buy-price' });

    // Compare-at price (strikethrough) — gated by the "Show compare-at price" block setting
    var showCompare = this.config.showCompareAtPrice !== false;
    var compare = showCompare && v && v.compareAtPrice && v.compareAtPrice > v.price
      ? el('span', { className: 'tc-buy-price-compare', textContent: this._fmt(v.compareAtPrice) })
      : null;
    if (compare) priceWrap.appendChild(compare);
    this.refs.buyCompare = compare;

    var priceVal = el('span', { className: 'tc-buy-price-value', textContent: this._fmt(v ? v.price : 0) });
    priceWrap.appendChild(priceVal);
    panel.appendChild(priceWrap);
    this.refs.buyPrice = priceVal;

    var benefits = el('div', { className: 'tc-benefits-inline' });
    [{ ico: 'truck', text: 'Free delivery' }, { ico: 'checkCircle', text: '2-year warranty' }, { ico: 'box', text: 'Yours to keep' }]
      .forEach(function (b) {
        var item = el('div', { className: 'tc-benefit-item' });
        item.innerHTML = icon(b.ico) + ' ' + b.text;
        benefits.appendChild(item);
      });
    panel.appendChild(benefits);

    if (this.config.hasSellingPlans) {
      var plans = this._availablePlans();
      var lowestPrice = Infinity;
      var pp = this.planPrices;
      plans.forEach(function (p) {
        var price = pp[p.id] || (self.variant ? self.variant.price : 0);
        if (price < lowestPrice) lowestPrice = price;
      });

      var nudge = el('div', { className: 'tc-nudge-card' });
      var nudgeLeft = el('div');
      var nudgeText = el('div', { className: 'tc-nudge-text', textContent: 'Or subscribe from ' + this._fmt(lowestPrice) + '/mo' });
      var nudgeSub = el('div', { className: 'tc-nudge-sub', textContent: 'Includes insurance, free delivery & returns' });
      nudgeLeft.appendChild(nudgeText);
      nudgeLeft.appendChild(nudgeSub);
      nudge.appendChild(nudgeLeft);

      var nudgeBtn = el('button', { type: 'button', className: 'tc-nudge-btn', textContent: self?.textContent?.nudgeCard?.button || 'View plans' });
      nudgeBtn.addEventListener('click', function () { self._switchTab('subscription'); });
      nudge.appendChild(nudgeBtn);

      panel.appendChild(nudge);
      this.refs.buyNudge = nudge;
      this.refs.nudgeText = nudgeText;
    }

    // Own-button mode: the widget renders its own Add-to-Cart on the Buy tab (the theme's native
    // button is hidden by _applyNativeButtonHide). In theme mode this is skipped and the theme's
    // own button stays the CTA, exactly as before. Buy has no T&C/insurance/deposit gate, so the
    // button starts enabled; _updateOwnButtonGate keeps it that way.
    if (this.buyButtonMode === 'own') {
      var buyAtc = el('button', { type: 'button', className: 'tc-atc tc-atc--buy', textContent: 'Add to cart' });
      buyAtc.addEventListener('click', function () { self._handleStandardAdd(); });
      panel.appendChild(buyAtc);
      this.refs.buyAtcBtn = buyAtc;
    }

    this.refs.buyPanel = panel;
    return panel;
  };

  W._renderSubscriptionPanel = function () {
    var self = this;
    var panel = el('div', { className: 'tc-panel', 'data-panel': 'subscription', 'data-active': 'false', role: 'tabpanel' });

    var plans = this._availablePlans();
    var count = Math.min(plans.length, 4);
    var pp = this.planPrices;
    var highestPrice = 0;
    plans.forEach(function (p) { var price = pp[p.id] || 0; if (price > highestPrice) highestPrice = price; });

    var grid = el('div', { className: 'tc-plans', 'data-count': String(count) });

    plans.slice(0, 4).forEach(function (plan, i) {
      var price = pp[plan.id] || 0;
      var isLast = i === count - 1;

      var btn = el('button', { type: 'button', className: 'tc-plan-btn', role: 'radio',
        'aria-checked': isLast ? 'true' : 'false', 'data-plan-id': String(plan.id) });

      if (isLast && count > 1) btn.appendChild(el('span', { className: 'tc-plan-badge', textContent: 'Best value' }));

      btn.appendChild(el('div', { className: 'tc-plan-duration', textContent: plan.name }));
      var priceDiv = el('div', { className: 'tc-plan-price' });
      priceDiv.innerHTML = self._fmt(price) + '<span class="tc-plan-per">/mo</span>';
      btn.appendChild(priceDiv);

      var savingsText = 'Most flexible';
      if (price !== highestPrice && highestPrice > 0) {
        var pct = Math.round(((highestPrice - price) / highestPrice) * 100);
        savingsText = pct > 0 ? 'Save ' + pct + '%' : 'Best value';
      }
      btn.appendChild(el('div', { className: 'tc-plan-savings', textContent: self.textContent.sellingPlans.labels[i] || savingsText }));

      btn.addEventListener('click', function () { self._selectPlan(plan.id); });
      grid.appendChild(btn);
    });

    panel.appendChild(grid);
    this.refs.planGrid = grid;

    var summaryLabels = (this.textContent && this.textContent.summary) || {};
    var summary = el('div', { className: 'tc-breakdown' });
    var termRow = el('div', { className: 'tc-breakdown-row' }, [
      el('span', { textContent: summaryLabels.minimumTermLabel || 'Minimum term' }), el('span', { textContent: '\u2014' })
    ]);
    var billingRow = el('div', { className: 'tc-breakdown-row' }, [
      el('span', { textContent: summaryLabels.billingLabel || 'Billed' }), el('span', { textContent: '\u2014' })
    ]);
    var priceRow = el('div', { className: 'tc-breakdown-row' }, [
      el('span', { textContent: summaryLabels.billingIntervalPriceLabel || 'Price per cycle' }), el('span', { textContent: '\u2014' })
    ]);
    summary.appendChild(termRow);
    summary.appendChild(billingRow);
    summary.appendChild(priceRow);
    panel.appendChild(summary);

    var benefits = el('div', { className: 'tc-benefits-inline' });
    [{ ico: 'truck', text: 'Free delivery & returns' }, { ico: 'refresh', text: 'Cancel anytime after your minimum term' }, { ico: 'shield', text: 'Wear & tear cover' }]
      .forEach(function (b) {
        var item = el('div', { className: 'tc-benefit-item' });
        item.innerHTML = icon(b.ico) + ' ' + b.text;
        benefits.appendChild(item);
      });
    panel.appendChild(benefits);

    this.refs.summaryTerm = termRow.lastElementChild;
    this.refs.summaryBillingRow = billingRow;
    this.refs.summaryBilling = billingRow.lastElementChild;
    this.refs.summaryPrice = priceRow.lastElementChild;
    this.refs.subscriptionPanel = panel;

    // Custom fields (merchant-configured questions) render above the T&C/insurance/deposit block.
    var subCustomFields = el('div', { className: 'tc-custom-fields' });
    panel.appendChild(subCustomFields);
    this.refs.subCustomFieldsContainer = subCustomFields;
    this._renderCustomFields(subCustomFields, 'subscription');

    // T&C gate, directly above the Add-to-Cart control. The subscribe/purchase tabs use the
    // theme's own product form submit button, which renders immediately after this widget on
    // the page, so appending last here puts the checkbox right above it.
    var subTermsGate = el('div', { className: 'tc-terms-gate' });
    panel.appendChild(subTermsGate);
    this.refs.subTermsGateContainer = subTermsGate;
    this._renderTermsGate(subTermsGate, 'subscription');

    // Insurance is optional (no Add-to-Cart gating), so it renders right below the T&C gate,
    // still above the theme's own Add-to-Cart button.
    var subInsuranceGate = el('div', { className: 'tc-insurance-gate' });
    panel.appendChild(subInsuranceGate);
    this.refs.subInsuranceGateContainer = subInsuranceGate;
    this._renderInsuranceGate(subInsuranceGate, 'subscription');

    // Deposit is mandatory (a checked, disabled checkbox, no opt-out - see the divergence note on
    // _renderDepositNotice), so it renders as a read-only row right below insurance, still above
    // the theme's own Add-to-Cart button.
    var subDepositNotice = el('div', { className: 'tc-deposit-notice' });
    panel.appendChild(subDepositNotice);
    this.refs.subDepositNoticeContainer = subDepositNotice;
    this._renderDepositNotice(subDepositNotice, 'subscription');

    // Own-button mode: the widget renders its own Add-to-Cart on the Subscribe tab, below the
    // gates (T&C / insurance / deposit), same position the rental button occupies. It starts
    // disabled and is reconciled by _updateOwnButtonGate against the same gate the theme button
    // uses (T&C accepted + any required deposit loaded). In theme mode this is skipped.
    if (this.buyButtonMode === 'own') {
      var subAtc = el('button', { type: 'button', className: 'tc-atc tc-atc--subscribe', textContent: 'Subscribe', disabled: 'disabled' });
      subAtc.addEventListener('click', function () { self._handleStandardAdd(); });
      panel.appendChild(subAtc);
      this.refs.subAtcBtn = subAtc;
    }

    if (plans.length > 0) {
      this._selectPlan(plans[Math.min(plans.length - 1, 3)].id);
    }

    return panel;
  };

  /* — Rent panel — */

  W._renderRentPanel = function () {
    var self = this;
    var panel = el('div', { className: 'tc-panel', 'data-panel': 'rental', 'data-active': 'false', role: 'tabpanel' });

    var dateRow = el('div', { className: 'tc-rental-dates' });
    // Inputs start disabled — re-enabled once _fetchRentalConstraints succeeds
    // and the calendar is built. Prevents click-but-nothing-happens UX.
    var startInput = el('input', { type: 'text', className: 'tc-rental-date-input', readOnly: 'readonly', disabled: 'disabled', placeholder: 'Start date', 'aria-label': 'Start date' });
    var endInput = el('input', { type: 'text', className: 'tc-rental-date-input', readOnly: 'readonly', disabled: 'disabled', placeholder: 'End date', 'aria-label': 'End date' });
    var dateSep = el('span', { className: 'tc-rental-date-sep', innerHTML: icon('calendar') });
    dateRow.appendChild(startInput);
    dateRow.appendChild(dateSep);
    dateRow.appendChild(endInput);
    panel.appendChild(dateRow);
    this.refs.rentalStartInput = startInput;
    this.refs.rentalEndInput = endInput;

    var status = el('div', { className: 'tc-rental-status', 'data-state': 'idle' });
    panel.appendChild(status);
    this.refs.rentalStatus = status;

    function openCal() {
      if (self.state.calendarInstance && self.state.calendarInstance.open) self.state.calendarInstance.open();
    }
    startInput.addEventListener('click', openCal);
    endInput.addEventListener('click', openCal);

    var breakdown = el('div', { className: 'tc-breakdown tc-rental-breakdown' });
    var periodRow = el('div', { className: 'tc-breakdown-row' }, [el('span', { textContent: 'Period' }), el('span', { textContent: '—' })]);
    var dailyRow = el('div', { className: 'tc-breakdown-row' }, [el('span', { textContent: 'Daily rate' }), el('span', { textContent: '—' })]);
    var totalRow = el('div', { className: 'tc-breakdown-row tc-breakdown-total' }, [el('span', { textContent: 'Total' }), el('span', { textContent: '—' })]);
    breakdown.appendChild(periodRow);
    breakdown.appendChild(dailyRow);
    breakdown.appendChild(totalRow);
    breakdown.style.display = 'none';
    panel.appendChild(breakdown);
    this.refs.rentalBreakdown = breakdown;
    this.refs.rentalPeriod = periodRow.lastElementChild;
    this.refs.rentalDailyRate = dailyRow.lastElementChild;
    this.refs.rentalTotal = totalRow.lastElementChild;

    var benefits = el('div', { className: 'tc-benefits-inline' });
    [{ ico: 'truck', text: 'Free delivery & returns' }, { ico: 'shield', text: 'Wear & tear cover' }, { ico: 'refresh', text: 'Flexible dates' }]
      .forEach(function (b) {
        var item = el('div', { className: 'tc-benefit-item' });
        item.innerHTML = icon(b.ico) + ' ' + b.text;
        benefits.appendChild(item);
      });
    panel.appendChild(benefits);

    // Custom fields (merchant-configured questions) render above the T&C/insurance/deposit block.
    var rentCustomFields = el('div', { className: 'tc-custom-fields' });
    panel.appendChild(rentCustomFields);
    this.refs.rentCustomFieldsContainer = rentCustomFields;
    this._renderCustomFields(rentCustomFields, 'rental');

    // T&C gate, directly above the rental Add-to-Cart button.
    var rentTermsGate = el('div', { className: 'tc-terms-gate' });
    panel.appendChild(rentTermsGate);
    this.refs.rentTermsGateContainer = rentTermsGate;
    this._renderTermsGate(rentTermsGate, 'rental');

    // Insurance is optional (no Add-to-Cart gating), so it renders right below the T&C gate,
    // still above the rental Add-to-Cart button.
    var rentInsuranceGate = el('div', { className: 'tc-insurance-gate' });
    panel.appendChild(rentInsuranceGate);
    this.refs.rentInsuranceGateContainer = rentInsuranceGate;
    this._renderInsuranceGate(rentInsuranceGate, 'rental');

    // Deposit is mandatory (a checked, disabled checkbox, no opt-out), so it renders as a read-only
    // row right below insurance, still above the rental Add-to-Cart button.
    var rentDepositNotice = el('div', { className: 'tc-deposit-notice' });
    panel.appendChild(rentDepositNotice);
    this.refs.rentDepositNoticeContainer = rentDepositNotice;
    this._renderDepositNotice(rentDepositNotice, 'rental');

    var atc = el('button', { type: 'button', className: 'tc-rental-atc tc-atc', textContent: 'Select dates to rent', disabled: 'disabled' });
    atc.addEventListener('click', function () { self._handleRentalAdd(); });
    panel.appendChild(atc);
    this.refs.rentalAtcBtn = atc;

    this.refs.rentPanel = panel;
    return panel;
  };

  /* Add-ons: Render */

  // The add-ons section is built once (after the fetch resolves) and lives in exactly one place
  // in the DOM at a time: whichever panel is currently active. Since only one panel is ever
  // visible (the others are display:none), moving the same node into the active panel on every
  // tab switch is simpler and avoids having to keep three duplicate rows' worth of form state in
  // sync, and it reads as "under the CTA on all three tabs" from the shopper's point of view.
  W._renderAddOns = function () {
    var self = this;
    var addOns = this.state.addOns;
    if (!this.config.showAddOns || !addOns || !addOns.length) return;

    var section = this.refs.addOnsSection;
    if (!section) {
      section = el('div', { className: 'tc-addons' });
      this.refs.addOnsSection = section;
    }
    section.innerHTML = '';

    var heading = (this.textContent.addOns && this.textContent.addOns.heading) || 'Add-ons';
    section.appendChild(el('div', { className: 'tc-addons-heading', textContent: heading }));

    var list = el('div', { className: 'tc-addons-list' });
    addOns.forEach(function (addOn) {
      list.appendChild(self._renderAddOnRow(addOn));
    });
    section.appendChild(list);

    this._moveAddOnsSectionToActivePanel();
  };

  // Places the (single, shared) add-ons section inside whichever panel matches the current tab.
  // Called both right after the section is (re)built and on every tab switch.
  W._moveAddOnsSectionToActivePanel = function () {
    var section = this.refs.addOnsSection;
    if (!section) return;
    var panelByTab = {
      purchase: this.refs.buyPanel,
      subscription: this.refs.subscriptionPanel,
      rental: this.refs.rentPanel,
    };
    var panel = panelByTab[this.state.currentTab];
    if (panel) panel.appendChild(section);
  };

  // Builds one add-on row: image, title, price of the selected/only variant, a variant picker
  // (only when there's more than one variant to choose from), a min-1 quantity stepper, and a
  // select toggle. Selecting/deselecting and changing variant or quantity all funnel through
  // syncSelection, which is the single place state.selectedAddOns is written.
  W._renderAddOnRow = function (addOn) {
    var self = this;
    var variants = addOn.variants || [];
    var row = el('div', { className: 'tc-addon-row', 'data-addon-id': String(addOn.addOnProductId) });

    if (addOn.imageUrl) {
      row.appendChild(el('img', { className: 'tc-addon-image', src: addOn.imageUrl, alt: addOn.title }));
    }

    var info = el('div', { className: 'tc-addon-info' });
    info.appendChild(el('div', { className: 'tc-addon-title', textContent: addOn.title }));

    var priceEl = el('div', { className: 'tc-addon-price' });
    info.appendChild(priceEl);

    var select = null;
    if (variants.length > 1) {
      select = el('select', { className: 'tc-addon-variant-select' });
      variants.forEach(function (v) {
        var opt = el('option', { value: v.internalId, textContent: v.title });
        if (v.isAvailable === false) opt.disabled = true;
        select.appendChild(opt);
      });
      info.appendChild(select);
    }
    row.appendChild(info);

    function currentVariant() {
      if (select) {
        var match = variants.find(function (v) { return v.internalId === select.value; });
        return match || variants[0] || null;
      }
      return variants[0] || null;
    }

    function updatePrice() {
      var v = currentVariant();
      priceEl.textContent = v ? self._fmtAmount(v.price) : '';
    }
    updatePrice();

    var controls = el('div', { className: 'tc-addon-controls' });

    var qtyWrap = el('div', { className: 'tc-addon-qty' });
    var minusBtn = el('button', { type: 'button', className: 'tc-addon-qty-btn', textContent: '−', 'aria-label': 'Decrease quantity' });
    var qtyInput = el('input', { type: 'number', className: 'tc-addon-qty-input', value: '1', min: '1', 'aria-label': 'Quantity' });
    var plusBtn = el('button', { type: 'button', className: 'tc-addon-qty-btn', textContent: '+', 'aria-label': 'Increase quantity' });
    qtyWrap.appendChild(minusBtn);
    qtyWrap.appendChild(qtyInput);
    qtyWrap.appendChild(plusBtn);
    controls.appendChild(qtyWrap);

    var toggleLabel = el('label', { className: 'tc-addon-toggle' });
    var checkbox = el('input', { type: 'checkbox', className: 'tc-addon-checkbox' });
    // A single out-of-stock variant has no picker to disable, and a multi-variant add-on whose
    // options are all disabled can still be checked (the picker just falls back to variants[0]
    // via currentVariant()), so disable the toggle itself whenever there is no available variant
    // left to add. oosDisabled marks it so the submit-in-flight guard below never re-enables it.
    if (variants.length > 0 && variants.every(function (v) { return v.isAvailable === false; })) {
      checkbox.disabled = true;
      checkbox.dataset.oosDisabled = 'true';
    }
    toggleLabel.appendChild(checkbox);
    toggleLabel.appendChild(el('span', { textContent: 'Add' }));
    controls.appendChild(toggleLabel);

    row.appendChild(controls);

    function currentQty() {
      var n = parseInt(qtyInput.value, 10);
      return (!n || n < 1) ? 1 : n;
    }

    function syncSelection() {
      if (!checkbox.checked) {
        delete self.state.selectedAddOns[addOn.addOnProductId];
      } else {
        var v = currentVariant();
        if (v) {
          self.state.selectedAddOns[addOn.addOnProductId] = {
            variantId: v.internalId,
            quantity: currentQty(),
          };
        }
      }
      // Keep the accelerated-checkout companion lines in step with the selection so an express
      // (wallet) purchase carries the same add-ons a normal cart add would.
      self._syncAdditionalItemsToForm();
    }

    checkbox.addEventListener('change', syncSelection);
    qtyInput.addEventListener('change', function () {
      qtyInput.value = String(currentQty());
      syncSelection();
    });
    minusBtn.addEventListener('click', function () {
      qtyInput.value = String(Math.max(1, currentQty() - 1));
      syncSelection();
    });
    plusBtn.addEventListener('click', function () {
      qtyInput.value = String(currentQty() + 1);
      syncSelection();
    });
    if (select) {
      select.addEventListener('change', function () {
        updatePrice();
        syncSelection();
      });
    }

    return row;
  };

  /* — Rental: API — */

  W._setRentalStatus = function (state, message) {
    if (this.refs.rentalStatus) {
      this.refs.rentalStatus.dataset.state = state;
      this.refs.rentalStatus.textContent = message || '';
    }
    var inputsEnabled = state === 'idle' && !!this.state.calendarInstance;
    if (this.refs.rentalStartInput) this.refs.rentalStartInput.disabled = !inputsEnabled;
    if (this.refs.rentalEndInput) this.refs.rentalEndInput.disabled = !inputsEnabled;
  };

  W._fetchRentalConstraints = function () {
    var self = this;
    if (!this.variant || !this.variant.wuvaVariantId || !this.config.apiBaseUrl) return;

    this._abortCtrl.abort();
    this._abortCtrl = new AbortController();

    this._setRentalStatus('loading', 'Loading availability…');

    var url = this.config.apiBaseUrl + '/product-variant/minimum-calendar-rental-dates/?productVariantId=' +
      encodeURIComponent(this.variant.wuvaVariantId.toUpperCase()) + '&api-version=1';

    fetch(url, { signal: this._abortCtrl.signal, headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.isSuccess || !data.value) {
          self._setRentalStatus('error', 'Couldn’t load rental availability. Please refresh and try again.');
          return;
        }
        self.state.rentalConstraints = data.value;
        self._initCalendar();
        self._setRentalStatus('idle');
        self._updateRentalButtonState();
      })
      .catch(function (e) {
        if (e.name === 'AbortError') return;
        console.error('[TC] Rental constraints failed:', e);
        self._setRentalStatus('error', 'Couldn’t load rental availability. Please refresh and try again.');
      });
  };

  // Fetches a T&C set's content (name/checkboxLabel/bodyHtml) from the brand-referrer,
  // caching by termsId so repeated tab switches/modal opens don't refetch. Never rejects:
  // on any failure (network error, non-2xx, isSuccess:false, e.g. the 400 not-found response,
  // or a malformed body) it resolves with a fallback so the checkbox still renders (using the
  // default label) and the modal still opens (empty) rather than breaking Add-to-Cart. The
  // fallback is intentionally not cached, so a later retry can still succeed.
  W._fetchTerms = function (clientId, termsId) {
    var self = this;
    var fallback = { name: '', checkboxLabel: TC_DEFAULT_TERMS_LABEL, bodyHtml: '' };

    if (this._termsCache[termsId]) {
      return Promise.resolve(this._termsCache[termsId]);
    }

    if (!this.config.apiBaseUrl || !clientId || !termsId) {
      console.error('[Total Commerce] Terms fetch: missing apiBaseUrl, clientId or termsId');
      return Promise.resolve(fallback);
    }

    var url = this.config.apiBaseUrl + '/terms/' + encodeURIComponent(clientId) + '/' + encodeURIComponent(termsId) + '?api-version=1';

    return fetch(url, { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.isSuccess || !data.value) {
          console.warn('[Total Commerce] Terms fetch: unexpected response', data);
          return fallback;
        }
        self._termsCache[termsId] = data.value;
        return data.value;
      })
      .catch(function (e) {
        console.error('[Total Commerce] Terms fetch failed:', e);
        return fallback;
      });
  };

  // Fetches an insurance profile's storefront detail (name/storefrontLabel/price/bodyHtml/
  // insuranceVariantInternalId) from the brand-referrer, caching by profileId so repeated tab
  // switches/modal opens don't refetch. Unlike _fetchTerms this has no gating role, so a failure
  // (network error, non-2xx, isSuccess:false - e.g. the profile is disabled/deleted/not found,
  // or a malformed body) resolves with null rather than a fallback object: the caller simply
  // hides the checkbox. The null result is intentionally not cached, so a later retry (e.g. the
  // merchant re-enables the profile, or a transient network blip clears) can still succeed.
  W._fetchInsurance = function (clientId, profileId) {
    var self = this;

    if (this._insuranceCache[profileId]) {
      return Promise.resolve(this._insuranceCache[profileId]);
    }

    if (!this.config.apiBaseUrl || !clientId || !profileId) {
      console.error('[Total Commerce] Insurance fetch: missing apiBaseUrl, clientId or profileId');
      return Promise.resolve(null);
    }

    var url = this.config.apiBaseUrl + '/insurance/' + encodeURIComponent(clientId) + '/' + encodeURIComponent(profileId) + '?api-version=1';

    return fetch(url, { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.isSuccess || !data.value) {
          console.warn('[Total Commerce] Insurance fetch: unexpected response', data);
          return null;
        }
        self._insuranceCache[profileId] = data.value;
        return data.value;
      })
      .catch(function (e) {
        console.error('[Total Commerce] Insurance fetch failed:', e);
        return null;
      });
  };

  // Fetches deposit detail (name/storefrontLabel/amount/bodyHtml/depositVariantInternalId) for
  // a deposit profile, caching by profileId. Mirrors _fetchInsurance exactly: a failure (network
  // error, non-2xx, isSuccess:false - e.g. the profile is disabled/deleted/not found, or a
  // malformed body) resolves with null rather than a fallback object, and the null result is
  // intentionally not cached so a later retry (e.g. the merchant re-enables the profile, or a
  // transient network blip clears) can still succeed. Unlike insurance, a null result here also
  // keeps Add-to-Cart blocked - see _depositGateSatisfied - rather than merely hiding a checkbox.
  W._fetchDeposit = function (clientId, profileId) {
    var self = this;

    if (this._depositCache[profileId]) {
      return Promise.resolve(this._depositCache[profileId]);
    }

    if (!this.config.apiBaseUrl || !clientId || !profileId) {
      console.error('[Total Commerce] Deposit fetch: missing apiBaseUrl, clientId or profileId');
      return Promise.resolve(null);
    }

    var url = this.config.apiBaseUrl + '/deposit/' + encodeURIComponent(clientId) + '/' + encodeURIComponent(profileId) + '?api-version=1';

    return fetch(url, { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.isSuccess || !data.value) {
          console.warn('[Total Commerce] Deposit fetch: unexpected response', data);
          return null;
        }
        self._depositCache[profileId] = data.value;
        return data.value;
      })
      .catch(function (e) {
        console.error('[Total Commerce] Deposit fetch failed:', e);
        return null;
      });
  };

  /* - Terms & Conditions: acceptance checkbox - */

  // Renders (or clears) the T&C gate into `container`, the wrapper owned by the panel for
  // `tab` ('subscription' or 'rental'). Tab-scoped so each panel's own gate is evaluated
  // against ITS OWN tab, not whichever tab happens to be globally current: only actually
  // builds the checkbox+link when `tab` is both the active tab AND has a termsId; any other
  // case (wrong tab, or no termsId) clears the container instead. This keeps exactly one
  // gate live at a time (the visible panel's), so this.refs.termsCheck always points at the
  // checkbox the customer can actually see and tick. Re-run from _refreshTermsGates on every
  // tab switch / variant change, since panels themselves are only built once (see _render).
  W._renderTermsGate = function (container, tab) {
    if (!container) return;

    // The checkbox this container currently owns (if any) is about to be destroyed,
    // so drop the shared ref: gating code (Task 17) must never read a detached element.
    if (this.refs.termsCheck && container.contains(this.refs.termsCheck)) {
      this.refs.termsCheck = null;
      this.refs.termsLink = null;
    }
    container.innerHTML = '';

    var termsId = this._termsIdForTab(tab);
    if (tab !== this.state.currentTab || !termsId) return;

    var self = this;
    var clientId = this.config.clientId;

    var checkbox = el('input', { type: 'checkbox', className: 'tc-terms-check' });
    checkbox.checked = !!this.state.termsAccepted[tab];
    checkbox.addEventListener('change', function () {
      self.state.termsAccepted[tab] = checkbox.checked;
      // Task 17 wires this up to actually gate Add-to-Cart. Guarded so this task
      // works standalone before that method exists.
      if (self._updateGateState) self._updateGateState();
    });

    var link = el('button', { type: 'button', className: 'tc-terms-link', textContent: TC_DEFAULT_TERMS_LABEL });
    link.addEventListener('click', function (e) {
      e.preventDefault();
      self._openTermsModal(clientId, termsId);
    });

    var label = el('label', { className: 'tc-terms-gate-label' }, [checkbox, ' ', link]);
    container.appendChild(label);

    this.refs.termsCheck = checkbox;
    this.refs.termsLink = link;

    // Fetch the real checkbox label in the background (cached, see _fetchTerms) and swap
    // it in once it lands. Guard against a stale resolve: if the user has since switched away
    // from `tab`, or this tab's own termsId has since changed (variant swap), drop the result;
    // whichever gate is now actually active has already rendered (and fetched for) itself.
    this._fetchTerms(clientId, termsId).then(function (res) {
      if (self.state.currentTab !== tab || self._termsIdForTab(tab) !== termsId) return;
      if (res && res.checkboxLabel) link.textContent = res.checkboxLabel;
    });
  };

  // Re-renders both panels' T&C gates, each scoped to its own tab. Called after every tab
  // switch and variant change so exactly one gate (the active panel's, or none) ever shows
  // content, and this.refs.termsCheck always tracks the checkbox actually visible.
  W._refreshTermsGates = function () {
    if (this.refs.subTermsGateContainer) this._renderTermsGate(this.refs.subTermsGateContainer, 'subscription');
    if (this.refs.rentTermsGateContainer) this._renderTermsGate(this.refs.rentTermsGateContainer, 'rental');
  };

  /* - Custom fields - */

  // Renders (or clears) the tab's configured custom fields into `container`, the wrapper owned by
  // the panel for `tab` ('subscription' or 'rental'). Tab-scoped like _renderTermsGate: only builds
  // when `tab` is the active tab and has fields; any other case clears the container. Values are
  // read from and written back to state.customFieldValues[tab] keyed by label, so entered answers
  // survive the re-renders driven by _refreshCustomFields on tab/variant change. Every keystroke
  // reconciles the gate (a required field that becomes empty must re-disable Add-to-Cart).
  W._renderCustomFields = function (container, tab) {
    if (!container) return;
    container.innerHTML = '';

    var fields = this._customFieldsForTab(tab);
    if (tab !== this.state.currentTab || !fields.length) return;

    var self = this;
    if (!this.state.customFieldValues[tab]) this.state.customFieldValues[tab] = {};
    var values = this.state.customFieldValues[tab];

    fields.forEach(function (field) {
      if (!field || !field.label) return;

      var isDate = field.type && String(field.type).toLowerCase() === 'date';
      var input;

      if (isDate) {
        // Date fields use the widget's own single-date calendar popover (same look as the rental
        // date picker) rather than a native date input: a read-only text field shows the chosen
        // date and clicking it opens the picker. State stores the raw ISO value (so
        // _formatCustomFieldValue and the gate keep working); the field displays the readable form.
        input = el('input', {
          type: 'text',
          className: 'tc-custom-field-input',
          readOnly: 'readonly',
          'aria-label': field.label,
          placeholder: 'Select a date',
        });
        if (values[field.label]) input.value = self._formatCustomFieldValue(field, values[field.label]);

        var openDatePicker = function () {
          self._ensureCustomDatePicker().openFor(input, {
            value: values[field.label] || null,
            onSelect: function (isoDate) {
              values[field.label] = isoDate;
              input.value = self._formatCustomFieldValue(field, isoDate);
              self._updateGateState();
            },
          });
        };
        input.addEventListener('click', openDatePicker);
      } else {
        input = el('input', {
          type: 'text',
          className: 'tc-custom-field-input',
          'aria-label': field.label,
        });
        if (values[field.label] != null) input.value = values[field.label];

        var onInput = function () {
          values[field.label] = input.value;
          self._updateGateState();
        };
        input.addEventListener('input', onInput);
        input.addEventListener('change', onInput);
      }

      if (field.required) input.setAttribute('aria-required', 'true');

      var labelText = field.label + (field.required ? ' *' : '');
      // Wrapping the input inside the <label> associates them without needing a generated id.
      var label = el('label', { className: 'tc-custom-field-label' }, [
        el('span', { className: 'tc-custom-field-label-text', textContent: labelText }),
        input,
      ]);
      container.appendChild(label);
    });
  };

  // Re-renders both panels' custom-field sections, each scoped to its own tab. Called after every
  // tab switch and variant change, exactly like _refreshTermsGates, since panels are built once.
  W._refreshCustomFields = function () {
    if (this.refs.subCustomFieldsContainer) this._renderCustomFields(this.refs.subCustomFieldsContainer, 'subscription');
    if (this.refs.rentCustomFieldsContainer) this._renderCustomFields(this.refs.rentCustomFieldsContainer, 'rental');
  };

  /* - Portaled surfaces: calendars and modals - */

  // Moves an element the widget owns to <body>, which the calendars and modals need so no theme
  // container can clip them. Custom properties only inherit down the DOM tree, so a <body> child
  // sees none of the theme-editor colours the app block declares inline on
  // .tc-purchase-options-block: every var() in those surfaces would otherwise fall back to the
  // built-in default (the widget's own green), or - where there is no fallback - drop the
  // declaration entirely and hand the colour over to whatever the theme says about `button` and
  // friends. Copying the block's --tc-* declarations onto the portaled element keeps it painting in
  // the merchant's configured palette. Always portal through here, never document.body.appendChild.
  W._portalToBody = function (element) {
    // Carries the .tc-widget-level defaults (surface, shadow, hairline...) to the portaled element,
    // which the stylesheet declares for .tc-widget and .tc-portal together.
    element.classList.add('tc-portal');

    var block = this.container && this.container.closest
      ? this.container.closest('.tc-purchase-options-block')
      : null;
    var vars = block && block.style;
    for (var i = 0; vars && i < vars.length; i++) {
      var name = vars[i];
      if (name.indexOf('--tc-') === 0) element.style.setProperty(name, vars.getPropertyValue(name));
    }
    document.body.appendChild(element);
    return element;
  };

  // A single shared single-date calendar popover for custom date fields. Created lazily and appended
  // to document.body once (like the rental calendar), then re-anchored and re-configured on each
  // openFor call. Reuses the .tc-cal* styling so it matches the rental range picker, but selects
  // exactly one date. Kept separate from _initCalendar, which is a range picker coupled to rental
  // constraints, pricing and plan prefetch.
  W._ensureCustomDatePicker = function () {
    if (this._customDatePicker) return this._customDatePicker;

    var container = el('div', { className: 'tc-cal', 'data-open': 'false', role: 'dialog' });
    container.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    container.addEventListener('click', function (e) { e.stopPropagation(); });
    this._portalToBody(container);

    var view = { anchor: null, selected: null, onSelect: null, isOpen: false, viewYear: 0, viewMonth: 0 };

    function parseIsoDateLocal(iso) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
      if (!m) return null;
      return startOfDay(new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10)));
    }

    function buildMonth(month, year, isFirst, isLast) {
      var wrap = el('div', { className: 'tc-cal-month' });
      var header = el('div', { className: 'tc-cal-header' });

      var prev = el('button', { type: 'button', className: 'tc-cal-nav', 'aria-label': 'Previous month' });
      prev.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M10 12 6 8l4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      if (!isFirst) prev.style.visibility = 'hidden';
      prev.addEventListener('click', function () {
        view.viewMonth -= 1;
        if (view.viewMonth < 0) { view.viewMonth = 11; view.viewYear -= 1; }
        render();
      });
      header.appendChild(prev);

      header.appendChild(el('div', { className: 'tc-cal-title', textContent: CAL_MONTHS[month] + ' ' + year }));

      var next = el('button', { type: 'button', className: 'tc-cal-nav', 'aria-label': 'Next month' });
      next.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      if (!isLast) next.style.visibility = 'hidden';
      next.addEventListener('click', function () {
        view.viewMonth += 1;
        if (view.viewMonth > 11) { view.viewMonth = 0; view.viewYear += 1; }
        render();
      });
      header.appendChild(next);
      wrap.appendChild(header);

      var wd = el('div', { className: 'tc-cal-weekdays' });
      CAL_WEEKDAYS.forEach(function (d) { wd.appendChild(el('div', { className: 'tc-cal-weekday', textContent: d })); });
      wrap.appendChild(wd);

      var grid = el('div', { className: 'tc-cal-days' });
      var firstWeekday = new Date(year, month, 1).getDay();
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      var today = startOfDay(new Date());

      for (var i = 0; i < firstWeekday; i++) grid.appendChild(el('div', { className: 'tc-cal-blank' }));

      for (var d = 1; d <= daysInMonth; d++) {
        (function (day) {
          var cellDate = startOfDay(new Date(year, month, day));
          var classes = ['tc-cal-day'];
          if (sameDay(cellDate, today)) classes.push('tc-cal-today');
          if (view.selected && sameDay(cellDate, view.selected)) classes.push('tc-cal-selected');
          var cell = el('button', { type: 'button', className: classes.join(' '), textContent: String(day) });
          cell.addEventListener('click', function () {
            view.selected = cellDate;
            if (view.onSelect) view.onSelect(fmtIsoDate(cellDate));
            picker.close();
          });
          grid.appendChild(cell);
        })(d);
      }

      wrap.appendChild(grid);
      return wrap;
    }

    function render() {
      var isMobile = window.innerWidth <= 640;
      var monthsToShow = isMobile ? 1 : 2;
      container.innerHTML = '';
      var monthsWrap = el('div', { className: 'tc-cal-months' });
      for (var i = 0; i < monthsToShow; i++) {
        var m = (view.viewMonth + i) % 12;
        var y = view.viewYear + Math.floor((view.viewMonth + i) / 12);
        monthsWrap.appendChild(buildMonth(m, y, i === 0, i === monthsToShow - 1));
      }
      container.appendChild(monthsWrap);
    }

    function reposition() {
      if (!view.anchor) return;
      var rect = view.anchor.getBoundingClientRect();
      var isMobile = window.innerWidth <= 640;
      var top = rect.bottom + window.scrollY + 8;
      if (isMobile) {
        container.style.left = '8px';
        container.style.right = '8px';
        container.style.width = 'auto';
        container.style.top = top + 'px';
      } else {
        container.style.left = (rect.left + window.scrollX) + 'px';
        container.style.right = '';
        container.style.width = '';
        container.style.top = top + 'px';
      }
    }

    function onOutside(e) {
      if (container.contains(e.target)) return;
      if (e.target === view.anchor) return;
      picker.close();
    }

    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { if (view.isOpen) { render(); reposition(); } }, 200);
    }
    window.addEventListener('resize', onResize);

    var picker = {
      openFor: function (input, opts) {
        view.anchor = input;
        view.selected = opts && opts.value ? parseIsoDateLocal(opts.value) : null;
        view.onSelect = (opts && opts.onSelect) || null;
        var base = view.selected || startOfDay(new Date());
        view.viewYear = base.getFullYear();
        view.viewMonth = base.getMonth();
        view.isOpen = true;
        container.dataset.open = 'true';
        render();
        reposition();
        setTimeout(function () { document.addEventListener('click', onOutside); }, 0);
      },
      close: function () {
        if (!view.isOpen) return;
        view.isOpen = false;
        container.dataset.open = 'false';
        document.removeEventListener('click', onOutside);
      },
    };

    this._customDatePicker = picker;
    return picker;
  };

  // Writes the tab's answered custom fields onto a cart-line `properties` object: one visible
  // property per answer (human-readable key = the field label, shown on the Shopify order, emails
  // and cart) plus a single hidden `_customFields` JSON carrier the order ingestion parses back
  // into order-item metadata (LineItemMetadataExtractor). Shared by the AJAX/own-button/rental
  // main line in _buildCartItems; no-op when nothing is answered.
  W._applyCustomFieldProperties = function (properties, tab) {
    var answers = this._collectCustomFieldAnswers(tab);
    if (!answers.length) return;
    answers.forEach(function (a) { properties[a.label] = a.value; });
    properties._customFields = JSON.stringify(answers);
  };

  // Mirrors the custom-field answers into the theme's product form as hidden properties[...] inputs
  // (a visible one per answer + the hidden _customFields carrier), so a native form submit and an
  // accelerated (wallet) checkout carry them the same way _syncSellingPlanToForm carries the selling
  // plan. Rebuilt from scratch into a single owned container on every reconcile so it never keeps
  // stale answers. The rental tab never uses the theme form (its own button / permalink carries the
  // answers via _buildCartItems / _navigateToCart), so it clears and returns.
  W._syncCustomFieldsToForm = function () {
    var form = this._getGateForm();
    if (!form) return;

    var container = form.querySelector('[data-tc-custom-fields]');
    if (!container) {
      container = document.createElement('div');
      container.setAttribute('data-tc-custom-fields', '1');
      container.hidden = true;
      form.appendChild(container);
    }
    container.innerHTML = '';

    if (this.state.currentTab !== 'purchase' && this.state.currentTab !== 'subscription') return;

    var answers = this._collectCustomFieldAnswers(this.state.currentTab);
    if (!answers.length) return;

    function addInput(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      container.appendChild(input);
    }

    answers.forEach(function (a) { addInput('properties[' + a.label + ']', a.value); });
    addInput('properties[_customFields]', JSON.stringify(answers));
  };

  /* - Insurance: optional add-on checkbox - */

  // Renders (or clears) the insurance checkbox into `container`, the wrapper owned by the panel
  // for `tab` ('subscription' or 'rental'). Mirrors _renderTermsGate's tab-scoping and stale-fetch
  // guarding, but with two differences: (1) insurance is optional, so there is no Add-to-Cart
  // gating - ticking/unticking never disables anything; (2) nothing is rendered until the fetch
  // resolves successfully, since the checkbox's own label needs the fetched price/storefrontLabel
  // (unlike the terms checkbox, which renders immediately with a default label and swaps in the
  // real one later). A missing tab id, an inactive tab, or a failed/disabled-profile fetch all
  // leave the container empty, so the block is simply absent rather than shown broken.
  W._renderInsuranceGate = function (container, tab) {
    if (!container) return;

    if (this.refs.insuranceCheck && container.contains(this.refs.insuranceCheck)) {
      this.refs.insuranceCheck = null;
      this.refs.insuranceLink = null;
    }
    container.innerHTML = '';
    this._loadedInsurance[tab] = null;

    var profileId = this._insuranceIdForTab(tab);
    if (tab !== this.state.currentTab || !profileId) return;

    var self = this;
    var clientId = this.config.clientId;

    // Render the checkbox SYNCHRONOUSLY (mirroring _renderTermsGate) so the append can never race
    // a second render of this same container: the synchronous innerHTML clear above always removes
    // the previous box first. It starts disabled because until the price detail lands _buildCartItems
    // has no variant id to add, so a premature tick would silently miss the cart line. The real
    // label (merchant label + live price) and the enabled state are patched in when the fetch lands.
    var checkbox = el('input', { type: 'checkbox', className: 'tc-insurance-check' });
    checkbox.checked = !!this.state.insuranceSelected[tab];
    checkbox.disabled = true;
    checkbox.addEventListener('change', function () {
      self.state.insuranceSelected[tab] = checkbox.checked;
      // Mirror the insurance selection into the accelerated-checkout companion lines so an
      // express (wallet) purchase carries it too.
      self._syncAdditionalItemsToForm();
    });

    var link = el('button', { type: 'button', className: 'tc-insurance-link', textContent: TC_DEFAULT_INSURANCE_LABEL });
    link.addEventListener('click', function (e) {
      e.preventDefault();
      self._openInsuranceModal(clientId, profileId);
    });

    var label = el('label', { className: 'tc-insurance-gate-label' }, [checkbox, ' ', link]);
    container.appendChild(label);

    this.refs.insuranceCheck = checkbox;
    this.refs.insuranceLink = link;

    // Fetch the live detail (label + price + the variant to add) in the background (cached, see
    // _fetchInsurance) and patch it into the already-rendered checkbox. Stale guard: if the user
    // has since switched away from `tab`, or this tab's own insurance id has changed (variant
    // swap), drop the result. On a null result (profile disabled/deleted/unprovisioned or a
    // network failure) there is no insurance to offer, so remove this placeholder gate - but only
    // if it is still the one on screen, since a newer synchronous render may have replaced it.
    this._fetchInsurance(clientId, profileId).then(function (detail) {
      if (self.state.currentTab !== tab || self._insuranceIdForTab(tab) !== profileId) return;
      if (!detail) {
        if (container.contains(checkbox)) {
          container.innerHTML = '';
          self._loadedInsurance[tab] = null;
          self.refs.insuranceCheck = null;
          self.refs.insuranceLink = null;
        }
        // The offer vanished for this tab - drop any insurance line we may have staged for the
        // accelerated path.
        self._syncAdditionalItemsToForm();
        return;
      }
      self._loadedInsurance[tab] = detail;
      link.textContent = detail.storefrontLabel + ' (+' + self._fmtAmount(detail.price) + ')';
      checkbox.disabled = false;
      // _buildInsuranceItem needs this now-loaded detail, and the selection can already be true
      // when re-entering a tab (state persists, detail is refetched), so this async resolve is
      // the point at which the accelerated-path insurance line becomes expressible - re-sync.
      self._syncAdditionalItemsToForm();
    });
  };

  // Re-renders both panels' insurance gates, each scoped to its own tab. Called after every tab
  // switch and variant change, mirroring _refreshTermsGates.
  W._refreshInsuranceGates = function () {
    if (this.refs.subInsuranceGateContainer) this._renderInsuranceGate(this.refs.subInsuranceGateContainer, 'subscription');
    if (this.refs.rentInsuranceGateContainer) this._renderInsuranceGate(this.refs.rentInsuranceGateContainer, 'rental');
  };

  /* - Deposit: required informational line - */

  // Renders (or clears) the read-only deposit notice into `container`, the wrapper owned by the
  // panel for `tab` ('subscription' or 'rental'). Mirrors _renderInsuranceGate's tab-scoping and
  // stale-fetch guarding, with two key differences: (1) the checkbox is rendered CHECKED and
  // DISABLED (read-only) - a deposit has no opt-out, so the box is a visual affordance matching the
  // T&C/insurance checkboxes above it and never gates anything itself (the gate lives in
  // _depositGateSatisfied); (2) it renders a placeholder SYNCHRONOUSLY
  // (mirroring the terms checkbox's immediate render, not insurance's "wait for the fetch"
  // approach), because until the fetch resolves the row's absence would look identical to "no
  // deposit configured" - and a configured-but-still-loading deposit must stay visible (and
  // Add-to-Cart visibly blocked, see _depositGateSatisfied) rather than silently vanish. Always
  // clears the container first (container.innerHTML = '') so a second render of this same
  // container can never race the first. Re-run from _refreshDepositNotices on every tab switch /
  // variant change, since panels themselves are only built once (see _render).
  W._renderDepositNotice = function (container, tab) {
    if (!container) return;

    container.innerHTML = '';
    this._loadedDeposit[tab] = null;

    var profileId = this._depositIdForTab(tab);
    if (tab !== this.state.currentTab || !profileId) {
      // Either this tab has no deposit requirement, or it isn't the active panel - either way
      // _depositGateSatisfied now reads a cleared this._loadedDeposit[tab], so re-evaluate the
      // gate rather than leaving a stale (possibly-blocked) state from a previous variant/tab.
      this._refreshDepositGate();
      return;
    }

    var self = this;
    var clientId = this.config.clientId;

    // Checked + disabled: the deposit is always included and can never be unticked. Purely a
    // visual affordance mirroring the insurance/T&C checkboxes; it carries no state and is not
    // read anywhere - the required-deposit gate lives entirely in _depositGateSatisfied.
    var checkbox = el('input', { type: 'checkbox', className: 'tc-deposit-check', checked: 'checked', disabled: 'disabled' });

    var link = el('button', { type: 'button', className: 'tc-deposit-link', textContent: TC_DEFAULT_DEPOSIT_LABEL + ' - checking…' });
    link.addEventListener('click', function (e) {
      e.preventDefault();
      self._openDepositModal(clientId, profileId);
    });

    var row = el('label', { className: 'tc-deposit-notice-label' }, [checkbox, ' ', link]);
    container.appendChild(row);
    this.refs.depositLink = link;

    // The row is present but not yet resolved, so the deposit half of the gate must stay
    // blocked (see _depositGateSatisfied) until the fetch below lands - re-evaluate now, not
    // only on resolution, so the theme's Add-to-Cart control disables immediately rather than
    // lagging one tick behind this render.
    this._refreshDepositGate();

    // Fetch the live detail (label + amount + the variant to add) in the background (cached,
    // see _fetchDeposit) and patch it into the already-rendered row. Stale guard: if the user has
    // since switched away from `tab`, or this tab's own deposit id has changed (variant swap),
    // drop the result; whichever notice is now actually active has already rendered (and
    // fetched for) itself.
    this._fetchDeposit(clientId, profileId).then(function (detail) {
      if (self.state.currentTab !== tab || self._depositIdForTab(tab) !== profileId) return;
      if (!detail) {
        // The deposit couldn't be loaded (network error, or a disabled/unprovisioned profile).
        // Unlike insurance (optional - a failed fetch just removes the checkbox), a configured
        // deposit is required, so the row stays as an explicit placeholder rather than
        // disappearing, and _refreshDepositGate below keeps Add-to-Cart blocked on this tab.
        self._loadedDeposit[tab] = null;
        if (container.contains(link)) link.textContent = TC_DEFAULT_DEPOSIT_LABEL + ' unavailable - please contact support';
        self._refreshDepositGate();
        return;
      }
      self._loadedDeposit[tab] = detail;
      link.textContent = (detail.storefrontLabel || TC_DEFAULT_DEPOSIT_LABEL) + ' (+' + self._fmtAmount(detail.amount) + ')';
      // _buildDepositItem needs this now-loaded detail on the accelerated (wallet) path too -
      // re-sync the hidden shopify-additional-items inputs (mirrors _renderInsuranceGate's own
      // resolution re-sync).
      self._syncAdditionalItemsToForm();
      // The deposit half of the gate can only pass once this resolves - re-evaluate so a
      // disabled theme button / rental ATC re-enables the moment it's actually safe to.
      self._refreshDepositGate();
    });
  };

  // Re-renders both panels' deposit notices, each scoped to its own tab. Called after every tab
  // switch and variant change, mirroring _refreshInsuranceGates.
  W._refreshDepositNotices = function () {
    if (this.refs.subDepositNoticeContainer) this._renderDepositNotice(this.refs.subDepositNoticeContainer, 'subscription');
    if (this.refs.rentDepositNoticeContainer) this._renderDepositNotice(this.refs.rentDepositNoticeContainer, 'rental');
  };

  /* - Terms & Conditions: Add-to-Cart gating - */

  // True when the given tab either has no deposit requirement at all, or its deposit detail has
  // loaded. False only while a CONFIGURED deposit is still loading (or failed to load) - this is
  // the required-deposit divergence from insurance: there is no "declined" state to be OK with,
  // only "not yet known to be payable". _isGatePassed folds this into Add-to-Cart gating below.
  W._depositGateSatisfied = function (tab) {
    return !this._depositIdForTab(tab) || !!this._loadedDeposit[tab];
  };

  // True when the active tab either doesn't require T&C acceptance at all, or its box has
  // been ticked, AND its deposit requirement (if any) is satisfied (see _depositGateSatisfied).
  // Purchase (and any variant lacking a termsId/depositId for the active tab) always passes.
  // The single source of truth both _updateRentalButtonState and the subscribe-tab gating below
  // consult - folding the deposit check in here, rather than threading a second condition
  // through every caller, is what makes "combine with the existing terms condition rather than
  // replacing it" (Task 14) actually true: one predicate, same downstream enable/disable path.
  W._isGatePassed = function () {
    var termsOk = !this._activeTermsId() || this.state.termsAccepted[this.state.currentTab] === true;
    return termsOk
      && this._depositGateSatisfied(this.state.currentTab)
      && this._customFieldsSatisfied(this.state.currentTab);
  };

  // Given whatever _getProductForm() returned - a Horizon <product-form-component> wrapper,
  // or a raw Dawn/generic <form> - resolves down to the actual <form> element to operate on.
  // Shared by _syncSellingPlanToForm and the subscribe-tab gate so the two never diverge on
  // how they unwrap the theme's markup.
  W._resolveFormElement = function (formComponent) {
    if (!formComponent) return null;
    var form = formComponent.querySelector ? (formComponent.querySelector('form') || formComponent) : formComponent;
    return (form && form.querySelectorAll) ? form : null;
  };

  W._getGateForm = function () {
    return this._resolveFormElement(this._getProductForm());
  };

  // Disables every theme submit control in `form` that isn't already disabled. Buttons the
  // theme itself disabled for its own reason (e.g. sold out) are left completely untouched -
  // they're skipped before we ever tag or track them, so _restoreGatedControls can never
  // re-enable something that wasn't ours to begin with.
  W._disableGatedControls = function (form) {
    var self = this;
    var controls = Array.from(form.querySelectorAll(TC_SUBMIT_SELECTOR));
    controls.forEach(function (btn) {
      if (btn.disabled) return; // already disabled (by us on a prior call, or by the theme) - leave as-is
      btn.disabled = true;
      btn.classList.add(TC_GATED_CLASS);
      btn.dataset.tcGated = '1';
      self._gatedButtons.push(btn);
    });
  };

  // Re-enables only the controls WE disabled (tracked in this._gatedButtons). Safe to call
  // even when nothing is currently gated (no-op), and safe to call when the form can no
  // longer be located, since it operates on the tracked element references directly rather
  // than re-querying the DOM.
  W._restoreGatedControls = function () {
    if (!this._gatedButtons.length) return;
    this._gatedButtons.forEach(function (btn) {
      if (!btn) return;
      btn.disabled = false;
      btn.classList.remove(TC_GATED_CLASS);
      delete btn.dataset.tcGated;
    });
    this._gatedButtons = [];
  };

  // Belt-and-braces safety net: even if the disabled attribute above is ever bypassed
  // (theme JS re-enables its own button on some interaction we don't observe, or a form
  // library submits programmatically), a capturing submit listener on the form and a
  // capturing click listener on each submit control both block the actual Add-to-Cart while
  // the active tab's T&C gate is failing OR (Task 14) its deposit gate hasn't loaded. Gated on
  // _isGatePassed() (not a specific tab), which already returns true when the active tab
  // requires neither terms nor a deposit, so a Buy-tab submit is never blocked. Bound once per
  // form (dataset marker) and once per submit control (dataset marker) so repeated calls from
  // _updateGateState (on every tab switch / variant change / checkbox change / deposit fetch
  // resolution) never stack duplicate listeners.
  W._bindTermsSubmitGuard = function (form) {
    var self = this;

    function blockIfGated(e) {
      if (!self._isGatePassed()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        // Distinguish which half of _isGatePassed actually failed so the error is never
        // misleading (e.g. telling a shopper to accept T&Cs when the real blocker is a
        // required deposit that hasn't loaded).
        if (!self._depositGateSatisfied(self.state.currentTab)) {
          self._showError('The required deposit could not be loaded. Please refresh and try again.');
        } else if (!self._customFieldsSatisfied(self.state.currentTab)) {
          self._showError('Please complete the required fields to continue.');
        } else {
          self._showError('Please accept the Terms & Conditions to continue.');
        }
      }
    }

    if (form.dataset.tcGateBound !== '1') {
      form.addEventListener('submit', blockIfGated, true);
      form.dataset.tcGateBound = '1';
    }

    var controls = Array.from(form.querySelectorAll(TC_SUBMIT_SELECTOR));
    controls.forEach(function (btn) {
      if (btn.dataset.tcClickGateBound === '1') return;
      btn.addEventListener('click', blockIfGated, true);
      btn.dataset.tcClickGateBound = '1';
    });
  };

  // Theme-button half of the gate: locates the theme's native product form and reconciles its
  // submit control(s) against the current gate state. Applies to ANY tab whose revenue model
  // requires T&C acceptance and/or a deposit - both the Subscribe tab and the Rent tab sit
  // alongside the theme's own Add-to-Cart button, which must be disabled too so an unaccepted
  // (or not-yet-deposit-loaded) customer can't bypass the gate via it. Gated on _isGatePassed(),
  // which already returns true for tabs that require neither (e.g. Buy), so the theme button is
  // only disabled when the active tab's checkbox is unticked or its deposit hasn't loaded. When
  // the form can't be found this cycle we simply skip - any earlier gating state is left exactly
  // as it was rather than guessed at, so a transient lookup miss can never spuriously re-enable
  // (or fail to disable) Add-to-Cart.
  W._updateThemeButtonGate = function () {
    var form = this._getGateForm();
    if (!form) return;

    this._bindTermsSubmitGuard(form);

    var shouldBlock = !this._isGatePassed();
    if (shouldBlock) this._disableGatedControls(form);
    else this._restoreGatedControls();
  };

  // Single reconciliation entry point for both tabs' Add-to-Cart gating. Call after any
  // change that could flip _isGatePassed()'s answer: init, tab switch, variant change, and
  // checkbox change (the last already wired up in _renderTermsGate).
  W._updateGateState = function () {
    this._updateRentalButtonState();
    this._updateThemeButtonGate();
    // The accelerated (wallet) button sits outside TC_SUBMIT_SELECTOR, so _updateThemeButtonGate
    // can't disable it. Reconcile its visibility off the same gate state here so an express
    // purchase can't bypass a required T&C acceptance (and so it's hidden on the Rent tab).
    this._updateAcceleratedCheckoutVisibility();
    // Own-button mode only: keep the theme's native submit hidden (re-applied here because the
    // theme can re-render its form on variant/section changes) and reconcile the widget's own
    // Buy/Subscribe buttons against the same gate the theme button uses.
    this._applyNativeButtonHide();
    this._updateOwnButtonGate();
    // Keep the theme form's hidden custom-field inputs in step with the current answers so a native
    // submit or wallet checkout carries them (no-op on the rental tab, which uses its own button).
    this._syncCustomFieldsToForm();
  };

  // Recomputes and (re)applies Add-to-Cart gating for terms AND deposit together, by delegating
  // to _updateGateState - the same reconciliation entry point (theme button, rental button,
  // accelerated-checkout visibility) the terms gate already uses. A distinct name exists so the
  // deposit-specific call sites are self-documenting: _renderDepositNotice's fetch resolution
  // (a new trigger _updateGateState alone didn't previously have), plus tab switch and variant
  // change, which already call _updateGateState directly - the deposit half of the gate lives
  // inside _isGatePassed / _depositGateSatisfied and needs no separate application step there.
  W._refreshDepositGate = function () {
    this._updateGateState();
  };

  /* — Buy-button mode (own vs theme) — */

  // Injects (once) the stylesheet that hides the theme's native submit control(s) when
  // TC_HIDE_NATIVE_CLASS is present. Deliberately scoped THROUGH that class on the theme's own
  // <form> (see _applyNativeButtonHide) rather than the section, so the generic submit selector
  // can never reach the widget's own buttons - they live outside the theme form. A style rule
  // (not an imperative hidden attribute) survives the theme re-rendering its button on
  // variant/section changes, mirroring _ensureAcceleratedHideStyle.
  W._ensureNativeHideStyle = function () {
    if (document.getElementById('tc-native-hide-style')) return;
    var style = document.createElement('style');
    style.id = 'tc-native-hide-style';
    style.textContent =
      '.' + TC_HIDE_NATIVE_CLASS + ' [type="submit"],' +
      '.' + TC_HIDE_NATIVE_CLASS + '[type="submit"],' +
      '.' + TC_HIDE_NATIVE_CLASS + ' [name="add"],' +
      '.' + TC_HIDE_NATIVE_CLASS + ' button.product-form__submit' +
      ' { display: none !important; }';
    document.head.appendChild(style);
  };

  // Own-button mode only: marks the theme's product form so its native Add-to-Cart is hidden,
  // leaving the widget's own button as the sole CTA on the Buy/Subscribe tabs. No-op in theme
  // mode. Re-applied from _updateGateState (init, tab switch, variant change) because the class
  // is set on the form element, which some themes replace when they re-render - reapplying keeps
  // the native button hidden across those redraws. When the form can't be found this cycle we
  // simply skip, same as _updateThemeButtonGate.
  W._applyNativeButtonHide = function () {
    if (this.buyButtonMode !== 'own') return;
    this._ensureNativeHideStyle();
    var form = this._getGateForm();
    if (!form) return;
    if (!form.classList.contains(TC_HIDE_NATIVE_CLASS)) form.classList.add(TC_HIDE_NATIVE_CLASS);
  };

  // Own-button mode only: reconciles the widget's own Buy/Subscribe buttons against the gate.
  // Only the active tab's button can block (the others are display:none anyway); it delegates to
  // _isGatePassed(), the same predicate the theme button uses, so subscribe stays disabled until
  // T&C is accepted and any required deposit has loaded, while Buy (which requires neither) is
  // always enabled. Skipped mid-add so it can't fight the busy-state disable in _handleStandardAdd.
  W._updateOwnButtonGate = function () {
    if (this.buyButtonMode !== 'own') return;
    if (this.state.addOnSubmitInFlight) return;
    var pass = this._isGatePassed();
    if (this.refs.buyAtcBtn) this.refs.buyAtcBtn.disabled = this.state.currentTab === 'purchase' ? !pass : false;
    if (this.refs.subAtcBtn) this.refs.subAtcBtn.disabled = this.state.currentTab === 'subscription' ? !pass : false;
  };

  // Disables both own buttons while an add is in flight; on release, hands back to
  // _updateOwnButtonGate to restore the correct per-tab gate state.
  W._setOwnButtonBusy = function (busy) {
    if (busy) {
      if (this.refs.buyAtcBtn) this.refs.buyAtcBtn.disabled = true;
      if (this.refs.subAtcBtn) this.refs.subAtcBtn.disabled = true;
    } else {
      this._updateOwnButtonGate();
    }
  };

  // Click handler for the widget's own Buy/Subscribe button (own-button mode only). Mirrors the
  // rental tab's _completeRentalAdd: it re-checks the gate (surfacing the same messaging as the
  // theme-button submit guard), then routes through the shared _addMultiLineToCart, which builds
  // the correct main line for the active tab (variant + quantity from the theme form, selling plan
  // for subscribe) plus any add-on/insurance/deposit lines, POSTs /cart/add.js and navigates to
  // /cart on success. Re-entrancy is guarded by the same state.addOnSubmitInFlight flag the rental
  // and form-intercept paths use, so a double click can't fire two POSTs.
  W._handleStandardAdd = function () {
    var self = this;
    if (this.state.currentTab !== 'purchase' && this.state.currentTab !== 'subscription') return;
    if (!this._isGatePassed()) {
      if (!this._depositGateSatisfied(this.state.currentTab)) {
        this._showError('The required deposit could not be loaded. Please refresh and try again.');
      } else if (!this._customFieldsSatisfied(this.state.currentTab)) {
        this._showError('Please complete the required fields to continue.');
      } else {
        this._showError('Please accept the Terms & Conditions to continue.');
      }
      return;
    }
    if (this.state.addOnSubmitInFlight) return;
    this.state.addOnSubmitInFlight = true;
    this._setAddOnSubmitDisabled(true);
    this._setOwnButtonBusy(true);

    this._addMultiLineToCart().then(function (ok) {
      self.state.addOnSubmitInFlight = false;
      self._setAddOnSubmitDisabled(false);
      self._setOwnButtonBusy(false);
      if (!ok) self._showError('Couldn’t add to cart. Please try again.');
      // On success _addMultiLineToCart has already navigated to /cart.
    });
  };

  /* - Terms & Conditions: modal - */

  // Lazily builds a single dialog + backdrop pair (reused across opens), mirroring
  // _initCalendar's create/backdrop/outside-click/escape pattern.
  W._ensureTermsModal = function () {
    if (this._termsModal) return this._termsModal;
    var self = this;

    var backdrop = el('div', { className: 'tc-terms-modal__backdrop', 'data-open': 'false' });
    backdrop.addEventListener('click', function () { self._closeTermsModal(); });

    var modal = el('div', { className: 'tc-terms-modal', 'data-open': 'false', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Terms & Conditions' });
    // Stop propagation so a click inside the modal doesn't bubble up and hit the
    // backdrop's own click-to-close listener (same pattern as .tc-cal).
    modal.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    modal.addEventListener('click', function (e) { e.stopPropagation(); });

    var header = el('div', { className: 'tc-terms-modal__header' });
    var heading = el('h2', { className: 'tc-terms-modal__heading', textContent: 'Terms & Conditions' });
    var closeBtn = el('button', { type: 'button', className: 'tc-terms-modal__close', 'aria-label': 'Close' });
    closeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    closeBtn.addEventListener('click', function () { self._closeTermsModal(); });
    header.appendChild(heading);
    header.appendChild(closeBtn);
    modal.appendChild(header);

    var body = el('div', { className: 'tc-terms-modal__body' });
    body.innerHTML = '<p class="tc-terms-modal__loading">Loading…</p>';
    modal.appendChild(body);

    self._portalToBody(backdrop);
    self._portalToBody(modal);

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') self._closeTermsModal();
    }

    this._termsModal = {
      backdrop: backdrop,
      modal: modal,
      heading: heading,
      body: body,
      isOpen: false,
      activeTermsId: null,
      onKeydown: onKeydown,
    };
    return this._termsModal;
  };

  // Opens the T&C modal for the given terms set, fetching its content (cached, see
  // _fetchTerms) and filling in the heading/body once it resolves. Opening the modal is
  // informational only: it does not itself accept the terms, ticking the checkbox does.
  W._openTermsModal = function (clientId, termsId) {
    var self = this;
    var m = this._ensureTermsModal();

    m.heading.textContent = 'Terms & Conditions';
    m.body.innerHTML = '<p class="tc-terms-modal__loading">Loading…</p>';
    m.backdrop.dataset.open = 'true';
    m.modal.dataset.open = 'true';
    m.isOpen = true;
    // Records which terms set THIS open is for, so a slow fetch from a previous open (a
    // different termsId) can't land after the modal has since been reopened for another tab.
    m.activeTermsId = termsId;
    document.addEventListener('keydown', m.onKeydown);

    this._fetchTerms(clientId, termsId).then(function (res) {
      // The modal may have been closed, or reopened for a different terms set, while this was
      // in flight, so only apply the result if it's still open AND still for this termsId.
      if (!m.isOpen || m.activeTermsId !== termsId) return;
      m.heading.textContent = (res && res.name) || 'Terms & Conditions';
      m.body.innerHTML = (res && res.bodyHtml) || '';
    });
  };

  W._closeTermsModal = function () {
    if (!this._termsModal || !this._termsModal.isOpen) return;
    var m = this._termsModal;
    m.isOpen = false;
    m.backdrop.dataset.open = 'false';
    m.modal.dataset.open = 'false';
    document.removeEventListener('keydown', m.onKeydown);
  };

  /* - Insurance: modal - */

  // Cloned from _ensureTermsModal rather than reused: the two modals can in principle be opened
  // for unrelated content (T&C vs insurance terms) and keeping them separate avoids threading an
  // extra "which content is this modal currently showing" guard through the shared instance.
  W._ensureInsuranceModal = function () {
    if (this._insuranceModal) return this._insuranceModal;
    var self = this;

    var backdrop = el('div', { className: 'tc-insurance-modal__backdrop', 'data-open': 'false' });
    backdrop.addEventListener('click', function () { self._closeInsuranceModal(); });

    var modal = el('div', { className: 'tc-insurance-modal', 'data-open': 'false', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Insurance' });
    modal.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    modal.addEventListener('click', function (e) { e.stopPropagation(); });

    var header = el('div', { className: 'tc-insurance-modal__header' });
    var heading = el('h2', { className: 'tc-insurance-modal__heading', textContent: 'Insurance' });
    var closeBtn = el('button', { type: 'button', className: 'tc-insurance-modal__close', 'aria-label': 'Close' });
    closeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    closeBtn.addEventListener('click', function () { self._closeInsuranceModal(); });
    header.appendChild(heading);
    header.appendChild(closeBtn);
    modal.appendChild(header);

    var body = el('div', { className: 'tc-insurance-modal__body' });
    body.innerHTML = '<p class="tc-insurance-modal__loading">Loading…</p>';
    modal.appendChild(body);

    self._portalToBody(backdrop);
    self._portalToBody(modal);

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') self._closeInsuranceModal();
    }

    this._insuranceModal = {
      backdrop: backdrop,
      modal: modal,
      heading: heading,
      body: body,
      isOpen: false,
      activeProfileId: null,
      onKeydown: onKeydown,
    };
    return this._insuranceModal;
  };

  // Opens the insurance modal for the given profile, fetching its content (cached, see
  // _fetchInsurance) and filling in the heading/body once it resolves. Opening the modal is
  // informational only - it does not tick the checkbox, and ticking the checkbox does not
  // require opening it.
  W._openInsuranceModal = function (clientId, profileId) {
    var self = this;
    var m = this._ensureInsuranceModal();

    m.heading.textContent = 'Insurance';
    m.body.innerHTML = '<p class="tc-insurance-modal__loading">Loading…</p>';
    m.backdrop.dataset.open = 'true';
    m.modal.dataset.open = 'true';
    m.isOpen = true;
    // Records which profile THIS open is for, so a slow fetch from a previous open (a different
    // profileId) can't land after the modal has since been reopened for another tab.
    m.activeProfileId = profileId;
    document.addEventListener('keydown', m.onKeydown);

    this._fetchInsurance(clientId, profileId).then(function (detail) {
      if (!m.isOpen || m.activeProfileId !== profileId) return;
      m.heading.textContent = (detail && detail.name) || 'Insurance';
      m.body.innerHTML = (detail && detail.bodyHtml) || '';
    });
  };

  W._closeInsuranceModal = function () {
    if (!this._insuranceModal || !this._insuranceModal.isOpen) return;
    var m = this._insuranceModal;
    m.isOpen = false;
    m.backdrop.dataset.open = 'false';
    m.modal.dataset.open = 'false';
    document.removeEventListener('keydown', m.onKeydown);
  };

  /* - Deposit: modal - */

  // Cloned from _ensureInsuranceModal rather than reused: the two modals can in principle be
  // opened for unrelated content (T&C/insurance terms vs deposit terms) and keeping them
  // separate avoids threading an extra "which content is this modal currently showing" guard
  // through a shared instance.
  W._ensureDepositModal = function () {
    if (this._depositModal) return this._depositModal;
    var self = this;

    var backdrop = el('div', { className: 'tc-deposit-modal__backdrop', 'data-open': 'false' });
    backdrop.addEventListener('click', function () { self._closeDepositModal(); });

    var modal = el('div', { className: 'tc-deposit-modal', 'data-open': 'false', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Deposit' });
    // Stop propagation so a click inside the modal doesn't bubble up and hit the
    // backdrop's own click-to-close listener (same pattern as .tc-cal).
    modal.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    modal.addEventListener('click', function (e) { e.stopPropagation(); });

    var header = el('div', { className: 'tc-deposit-modal__header' });
    var heading = el('h2', { className: 'tc-deposit-modal__heading', textContent: 'Deposit' });
    var closeBtn = el('button', { type: 'button', className: 'tc-deposit-modal__close', 'aria-label': 'Close' });
    closeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    closeBtn.addEventListener('click', function () { self._closeDepositModal(); });
    header.appendChild(heading);
    header.appendChild(closeBtn);
    modal.appendChild(header);

    var body = el('div', { className: 'tc-deposit-modal__body' });
    body.innerHTML = '<p class="tc-deposit-modal__loading">Loading…</p>';
    modal.appendChild(body);

    self._portalToBody(backdrop);
    self._portalToBody(modal);

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') self._closeDepositModal();
    }

    this._depositModal = {
      backdrop: backdrop,
      modal: modal,
      heading: heading,
      body: body,
      isOpen: false,
      activeProfileId: null,
      onKeydown: onKeydown,
    };
    return this._depositModal;
  };

  // Opens the deposit modal for the given profile, fetching its content (cached, see
  // _fetchDeposit) and filling in the heading/body once it resolves. Opening the modal is
  // informational only: whether the deposit line ends up in the cart is decided entirely by
  // _depositGateSatisfied / _buildDepositItem, not by whether this was ever opened - unlike the
  // insurance/terms modals there is no companion checkbox for this to feed.
  W._openDepositModal = function (clientId, profileId) {
    var self = this;
    var m = this._ensureDepositModal();

    m.heading.textContent = 'Deposit';
    m.body.innerHTML = '<p class="tc-deposit-modal__loading">Loading…</p>';
    m.backdrop.dataset.open = 'true';
    m.modal.dataset.open = 'true';
    m.isOpen = true;
    // Records which profile THIS open is for, so a slow fetch from a previous open (a different
    // profileId) can't land after the modal has since been reopened for another tab.
    m.activeProfileId = profileId;
    document.addEventListener('keydown', m.onKeydown);

    this._fetchDeposit(clientId, profileId).then(function (detail) {
      if (!m.isOpen || m.activeProfileId !== profileId) return;
      m.heading.textContent = (detail && detail.name) || 'Deposit';
      m.body.innerHTML = (detail && detail.bodyHtml) || '';
    });
  };

  W._closeDepositModal = function () {
    if (!this._depositModal || !this._depositModal.isOpen) return;
    var m = this._depositModal;
    m.isOpen = false;
    m.backdrop.dataset.open = 'false';
    m.modal.dataset.open = 'false';
    document.removeEventListener('keydown', m.onKeydown);
  };

  /* Add-ons: API */

  // Fetches the parent product's add-ons from the anonymous brand-referrer endpoint. Called
  // once at init (not per-tab): add-ons are the same list regardless of which tab is active.
  // Gated on the show_add_ons block setting plus the addOns marker metafield being a non-empty
  // array (the JS never guesses; Liquid tells it whether there is anything to fetch). Mirrors
  // _fetchRentalConstraints's abortable-fetch and Result-envelope pattern; failure is graceful,
  // the add-ons section simply stays unrendered.
  W._fetchAddOns = function () {
    if (!this.config.showAddOns || !this.config.addOns || !this.config.addOns.length || !this.config.clientId || !this.config.apiBaseUrl) {
      return;
    }

    var url = this.config.apiBaseUrl + '/product/' + encodeURIComponent(this.config.clientId)
      + '/add-ons?parentProductId=' + encodeURIComponent(this.config.parentProductId) + '&api-version=1';
    var self = this;

    fetch(url, { signal: this._abortCtrl.signal, headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.isSuccess && data.value) {
          self.state.addOns = data.value;
          self._renderAddOns();
        }
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        console.error('[Total Commerce] Add-ons fetch failed:', e);
        /* graceful: leave add-ons section unrendered */
      });
  };

  /* — Rental: Calendar — */

  W._initCalendar = function () {
    if (this.state.calendarInstance) {
      // Variant changed — destroy and rebuild with new min date.
      this.state.calendarInstance.destroy();
      this.state.calendarInstance = null;
    }
    var self = this;
    var constraints = this.state.rentalConstraints;
    var initMin = constraints && constraints.startDate ? startOfDay(new Date(constraints.startDate)) : startOfDay(new Date());

    var cal = {
      viewYear: initMin.getFullYear(),
      viewMonth: initMin.getMonth(),
      startDate: null,
      endDate: null,
      minDate: initMin,
      hoverDate: null,
      isOpen: false,
    };

    var container = el('div', { className: 'tc-cal', 'data-open': 'false', role: 'dialog' });
    container.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    container.addEventListener('click', function (e) { e.stopPropagation(); });
    this._portalToBody(container);
    cal.container = container;

    function isDisabled(cellDate) {
      if (cellDate < cal.minDate) return true;
      if (cal.startDate && !cal.endDate) {
        if (daysBetween(cal.startDate, cellDate) + 1 > MAX_RENTAL_DAYS) return true;
      }
      return false;
    }

    function buildMonth(month, year, isFirst, isLast) {
      var wrap = el('div', { className: 'tc-cal-month' });
      var header = el('div', { className: 'tc-cal-header' });

      var prev = el('button', { type: 'button', className: 'tc-cal-nav', 'aria-label': 'Previous month' });
      prev.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M10 12 6 8l4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      if (!isFirst) prev.style.visibility = 'hidden';
      prev.addEventListener('click', function () {
        cal.viewMonth -= 1;
        if (cal.viewMonth < 0) { cal.viewMonth = 11; cal.viewYear -= 1; }
        render();
      });
      header.appendChild(prev);

      header.appendChild(el('div', { className: 'tc-cal-title', textContent: CAL_MONTHS[month] + ' ' + year }));

      var next = el('button', { type: 'button', className: 'tc-cal-nav', 'aria-label': 'Next month' });
      next.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      if (!isLast) next.style.visibility = 'hidden';
      next.addEventListener('click', function () {
        cal.viewMonth += 1;
        if (cal.viewMonth > 11) { cal.viewMonth = 0; cal.viewYear += 1; }
        render();
      });
      header.appendChild(next);
      wrap.appendChild(header);

      var wd = el('div', { className: 'tc-cal-weekdays' });
      CAL_WEEKDAYS.forEach(function (d) { wd.appendChild(el('div', { className: 'tc-cal-weekday', textContent: d })); });
      wrap.appendChild(wd);

      var grid = el('div', { className: 'tc-cal-days' });
      var firstWeekday = new Date(year, month, 1).getDay();
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      var today = startOfDay(new Date());

      for (var i = 0; i < firstWeekday; i++) grid.appendChild(el('div', { className: 'tc-cal-blank' }));

      for (var d = 1; d <= daysInMonth; d++) {
        (function (day) {
          var cellDate = startOfDay(new Date(year, month, day));
          var classes = ['tc-cal-day'];
          var disabled = isDisabled(cellDate);

          if (disabled) classes.push('tc-cal-disabled');
          if (sameDay(cellDate, today)) classes.push('tc-cal-today');
          if (sameDay(cellDate, cal.startDate)) classes.push('tc-cal-start');
          if (sameDay(cellDate, cal.endDate)) classes.push('tc-cal-end');
          if (cal.startDate && cal.endDate && cellDate > cal.startDate && cellDate < cal.endDate) classes.push('tc-cal-inrange');
          if (cal.startDate && !cal.endDate && cal.hoverDate && cal.hoverDate > cal.startDate) {
            if (cellDate > cal.startDate && cellDate < cal.hoverDate) classes.push('tc-cal-inrange');
            if (sameDay(cellDate, cal.hoverDate) && !disabled) classes.push('tc-cal-hover-end');
          }

          var cell = el('button', { type: 'button', className: classes.join(' '), textContent: String(day) });
          if (disabled) cell.disabled = true;

          cell.addEventListener('click', function () {
            if (cell.disabled) return;
            var minDays = (self.state.rentalConstraints && self.state.rentalConstraints.minimumRentalPeriodInDays) || 1;
            if (!cal.startDate || (cal.startDate && cal.endDate)) {
              cal.startDate = cellDate; cal.endDate = null;
              self._setRentalDates(cellDate, null);
              render();
              return;
            }
            // Clicking before the start moves the start. Clicking the start itself closes a
            // same-day booking when the minimum allows one; on a longer minimum there is no
            // such booking to close, so it moves the start instead.
            if (cellDate < cal.startDate || (sameDay(cellDate, cal.startDate) && minDays > 1)) {
              cal.startDate = cellDate; cal.endDate = null;
              self._setRentalDates(cellDate, null);
              render();
              return;
            }
            var endDate = cellDate;
            var rawDays = daysBetween(cal.startDate, endDate) + 1;
            if (rawDays > MAX_RENTAL_DAYS) {
              cal.startDate = null; cal.endDate = null;
              self._setRentalDates(null, null);
              render();
              return;
            }
            if (rawDays < minDays) {
              endDate = new Date(cal.startDate);
              endDate.setDate(endDate.getDate() + minDays - 1);
            }
            cal.endDate = endDate;
            self._setRentalDates(cal.startDate, endDate);
            render();
            setTimeout(function () { cal.close(); }, 200);
          });

          cell.addEventListener('mouseenter', function () {
            if (!cal.startDate || cal.endDate || disabled) return;
            if (sameDay(cal.hoverDate, cellDate)) return;
            cal.hoverDate = cellDate;
            render();
          });

          grid.appendChild(cell);
        })(d);
      }

      wrap.appendChild(grid);
      return wrap;
    }

    function render() {
      var isMobile = window.innerWidth <= 640;
      var monthsToShow = isMobile ? 1 : 2;
      container.innerHTML = '';
      var monthsWrap = el('div', { className: 'tc-cal-months' });
      for (var i = 0; i < monthsToShow; i++) {
        var m = (cal.viewMonth + i) % 12;
        var y = cal.viewYear + Math.floor((cal.viewMonth + i) / 12);
        monthsWrap.appendChild(buildMonth(m, y, i === 0, i === monthsToShow - 1));
      }
      container.appendChild(monthsWrap);
    }

    function reposition() {
      var rect = self.refs.rentalStartInput.getBoundingClientRect();
      var isMobile = window.innerWidth <= 640;
      var top = rect.bottom + window.scrollY + 8;
      if (isMobile) {
        container.style.left = '8px';
        container.style.right = '8px';
        container.style.width = 'auto';
        container.style.top = top + 'px';
      } else {
        container.style.left = (rect.left + window.scrollX) + 'px';
        container.style.right = '';
        container.style.width = '';
        container.style.top = top + 'px';
      }
    }

    function onOutside(e) {
      if (container.contains(e.target)) return;
      if (e.target === self.refs.rentalStartInput || e.target === self.refs.rentalEndInput) return;
      cal.close();
    }

    cal.open = function () {
      if (cal.isOpen) return;
      cal.isOpen = true;
      container.dataset.open = 'true';
      if (cal.startDate) {
        cal.viewYear = cal.startDate.getFullYear();
        cal.viewMonth = cal.startDate.getMonth();
      }
      render();
      reposition();
      setTimeout(function () { document.addEventListener('click', onOutside); }, 0);
    };

    cal.close = function () {
      if (!cal.isOpen) return;
      cal.isOpen = false;
      container.dataset.open = 'false';
      cal.hoverDate = null;
      document.removeEventListener('click', onOutside);
    };

    cal.destroy = function () {
      cal.close();
      if (container.parentNode) container.parentNode.removeChild(container);
      window.removeEventListener('resize', onResize);
    };

    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { if (cal.isOpen) { render(); reposition(); } }, 200);
    }
    window.addEventListener('resize', onResize);

    this.state.calendarInstance = cal;
  };

  W._setRentalDates = function (start, end) {
    this.state.rentalDates = { start: start, end: end };
    if (this.refs.rentalStartInput) this.refs.rentalStartInput.value = start ? fmtDateLabel(start) : '';
    if (this.refs.rentalEndInput) this.refs.rentalEndInput.value = end ? fmtDateLabel(end) : '';
    this._updateRentalPricing();
    this._updateRentalButtonState();

    // Prefetch the selling plan in the background so clicking Rent navigates instantly.
    // If dates are incomplete (single-click selection), this is a no-op and any
    // in-flight prepare gets aborted.
    this._prepareRentalPlan();
  };

  function rentalDatesKey(start, end) {
    return start && end ? fmtIsoDate(start) + '|' + fmtIsoDate(end) : null;
  }

  W._cancelInFlightRentalPrepare = function () {
    if (this.state.preparePlanAbortCtrl) {
      this.state.preparePlanAbortCtrl.abort();
      this.state.preparePlanAbortCtrl = null;
    }
    this.state.preparingPlanKey = null;
  };

  W._prepareRentalPlan = function () {
    var self = this;
    var dates = this.state.rentalDates;
    var key = rentalDatesKey(dates.start, dates.end);

    // No valid date range yet — clear pending state. If we had a cached plan
    // for an earlier range (most common: customer clicked first date of a new
    // selection, or switched variants), abandon it so it doesn't linger until
    // the nightly sweep.
    if (!key) {
      this._cancelInFlightRentalPrepare();
      if (this.state.preparedPlan) {
        this._abandonRentalPlan(this.state.preparedPlan);
      }
      this.state.preparedPlan = null;
      return;
    }

    // Gating inputs missing — silently skip; _handleRentalAdd's own validation
    // will surface a UI error if the user later clicks Rent.
    if (!this.variant || !this.variant.wuvaVariantId || !this.config.clientId || !this.config.apiBaseUrl) {
      return;
    }

    // Cached plan for these exact dates is still valid — nothing to do.
    if (this.state.preparedPlan && this.state.preparedPlan.key === key) return;

    // Same key already being prepared — let it complete.
    if (this.state.preparingPlanKey === key) return;

    // Different key in flight — abort it; its result will be discarded by the
    // staleness check inside the .then below in case the abort lost the race.
    this._cancelInFlightRentalPrepare();

    // If we had a cached plan for a different date range, ask the backend to
    // delete the Shopify plan now (rather than waiting for the nightly sweep).
    // Fire-and-forget — failure is non-fatal, the sweep is the safety net.
    if (this.state.preparedPlan && this.state.preparedPlan.key !== key) {
      this._abandonRentalPlan(this.state.preparedPlan);
    }
    this.state.preparedPlan = null;

    this.state.preparingPlanKey = key;
    this.state.preparePlanAbortCtrl = new AbortController();

    var ctrl = this.state.preparePlanAbortCtrl;
    var capturedDates = { start: dates.start, end: dates.end };

    var url = this.config.apiBaseUrl + '/selling-plan/' + encodeURIComponent(this.config.clientId) + '/calendar-rental?api-version=1';
    var body = {
      productVariantId: this.variant.wuvaVariantId,
      startDate: fmtIsoDate(dates.start),
      endDate: fmtIsoDate(dates.end),
    };

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: ctrl.signal,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Stale — dates changed (or the widget moved on) while we were waiting.
        // The plan exists in Shopify regardless of our abort, so fire the abandon
        // call to clean it up promptly instead of leaving it for the nightly sweep.
        if (self.state.preparingPlanKey !== key) {
          if (data && data.isSuccess && data.value && data.value.sellingPlanInternalId) {
            self._abandonRentalPlan({
              sellingPlanInternalId: data.value.sellingPlanInternalId
            });
          }
          return;
        }
        self.state.preparingPlanKey = null;

        if (!data || !data.isSuccess || !data.value || !data.value.sellingPlanInternalId) {
          console.error('[Total Commerce] Rental prepare: unexpected response', data);
          return;
        }

        self.state.preparedPlan = {
          key: key,
          planId: extractNumericId(data.value.sellingPlanInternalId),
          // Keep the full Shopify GID so we can fire the abandon call when this
          // cached plan is invalidated (dates change / variant change).
          sellingPlanInternalId: data.value.sellingPlanInternalId,
          startDate: capturedDates.start,
          endDate: capturedDates.end,
        };

        // User already clicked Rent and is waiting, so finish the add now.
        if (self.state.rentalRequestInFlight) {
          self._completeRentalAdd(self.state.preparedPlan);
        }
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return; // expected when dates change
        console.error('[Total Commerce] Rental prepare failed:', e);
        if (self.state.preparingPlanKey === key) {
          self.state.preparingPlanKey = null;
        }
        // Don't surface a UI error proactively — wait for the user to click Rent
        // and treat that as a fresh attempt with visible feedback.
        if (self.state.rentalRequestInFlight) {
          self.state.rentalRequestInFlight = false;
          self._showError('Couldn’t set up your rental. Please try again.');
          self._updateRentalButtonState();
        }
      });
  };

  W._navigateToCart = function (preparedPlan) {
    var params = new URLSearchParams();
    params.set('id', extractNumericId(this.variant.id));
    params.set('quantity', '1');
    params.set('selling_plan', preparedPlan.planId);
    params.append('properties[_revenueModel]', 'calendar-rental');
    // Visible (no underscore) line-item property so the rental window shows on the cart line and at
    // checkout. Booked-at snapshot: it is copied onto the placed order and can't be edited there
    // after a later date modification (the order note stays canonical). The cart is always current.
    if (preparedPlan.startDate && preparedPlan.endDate) {
      params.append('properties[Rental dates]', fmtDateLabelWithYear(preparedPlan.startDate) + ' - ' + fmtDateLabelWithYear(preparedPlan.endDate));
    }
    // Carry the rental tab's answered custom fields (visible per-answer properties + the hidden
    // _customFields carrier) on the single-line permalink add, same shape as _buildCartItems.
    var customFieldAnswers = this._collectCustomFieldAnswers('rental');
    customFieldAnswers.forEach(function (a) { params.append('properties[' + a.label + ']', a.value); });
    if (customFieldAnswers.length) {
      params.append('properties[_customFields]', JSON.stringify(customFieldAnswers));
    }
    window.location.href = '/cart/add?' + params.toString();
  };

  // Rental ATC funnels through here instead of calling _navigateToCart directly: with add-ons,
  // insurance and/or a required deposit present, a full-page permalink add can only ever add the
  // single rental line, so it's replaced by the same AJAX multi-add used by the other tabs. None
  // present keeps the existing permalink navigation byte-for-byte unchanged.
  W._completeRentalAdd = function (preparedPlan) {
    var self = this;
    var hasAddOns = Object.keys(this.state.selectedAddOns).length > 0;
    var hasInsurance = !!(this._loadedInsurance.rental && this.state.insuranceSelected.rental);
    // Unlike insurance, the deposit needs no companion "selected" check - it has no opt-out, so
    // its mere presence (this._loadedDeposit.rental set) is enough to require the multi-add path.
    var hasDeposit = !!this._loadedDeposit.rental;
    if (!hasAddOns && !hasInsurance && !hasDeposit) {
      this._navigateToCart(preparedPlan);
      return;
    }
    // Same re-entrancy guard as _onFormSubmit: without it, two rapid clicks while a prepared
    // plan is already cached (the cache-hit branch in _handleRentalAdd calls straight in here,
    // with no synchronous flag/disable of its own) would fire two /cart/add.js POSTs.
    if (this.state.addOnSubmitInFlight) return;
    this.state.addOnSubmitInFlight = true;
    this._setAddOnSubmitDisabled(true);

    this._addMultiLineToCart().then(function (ok) {
      self.state.addOnSubmitInFlight = false;
      self._setAddOnSubmitDisabled(false);
      if (!ok) {
        self.state.rentalRequestInFlight = false;
        self._showError('Couldn’t add to cart. Please try again.');
        self._updateRentalButtonState();
      }
      // On success _addMultiLineToCart has already navigated to /cart, so don't abandon the
      // prepared plan: it's now a live line on an order, not an unused prefetch.
    });
  };

  // Builds the /cart/add.js items array for a multi-line add: the main line for whichever tab
  // is active, followed by one line per selected add-on. Add-ons are always a one-off purchase
  // regardless of the main line's revenue model (v1 scope). Mirrors tc-membership-embed.js's
  // addMembership() for the items shape/headers.
  W._buildCartItems = function () {
    var self = this;
    var items = [];

    // Buy/Subscribe: the theme's native product form owns the quantity selector, so the main
    // line has to mirror whatever the shopper set there. Rental has no such selector (its cart
    // add is always a single unit, same as the _navigateToCart permalink), so it keeps quantity 1.
    var mainQuantity = 1;
    if (this.state.currentTab === 'purchase' || this.state.currentTab === 'subscription') {
      var formEl = this._getFormElement();
      var qtyInput = formEl ? formEl.querySelector('input[name="quantity"]') : null;
      var parsedQty = qtyInput ? parseInt(qtyInput.value, 10) : NaN;
      mainQuantity = (!isNaN(parsedQty) && parsedQty >= 1) ? parsedQty : 1;
    }

    var main = { id: extractNumericId(this.variant.id), quantity: mainQuantity, properties: {} };
    if (this.state.currentTab === 'subscription' && this.state.selectedPlanId) {
      main.selling_plan = this.state.selectedPlanId;
      main.properties._revenue_model = 'subscription';
    } else if (this.state.currentTab === 'rental' && this.state.preparedPlan) {
      main.selling_plan = this.state.preparedPlan.planId;
      main.properties._revenueModel = 'calendar-rental';
      // Same visible line-item property _navigateToCart sets, so the rental window still shows
      // on the cart line and at checkout when the add is done via this AJAX path.
      if (this.state.preparedPlan.startDate && this.state.preparedPlan.endDate) {
        main.properties['Rental dates'] = fmtDateLabelWithYear(this.state.preparedPlan.startDate) + ' - ' + fmtDateLabelWithYear(this.state.preparedPlan.endDate);
      }
    } else {
      main.properties._revenue_model = 'purchase';
    }

    // Stamp the shopper's answers to the active tab's custom fields onto the main line.
    this._applyCustomFieldProperties(main.properties, this.state.currentTab);

    items.push(main);

    this._buildAddOnItems().forEach(function (item) { items.push(item); });

    var insuranceItem = this._buildInsuranceItem();
    if (insuranceItem) items.push(insuranceItem);

    var depositItem = this._buildDepositItem();
    if (depositItem) items.push(depositItem);

    return items;
  };

  // One cart line per selected add-on. Add-ons are always a one-off purchase regardless of the
  // main line's revenue model (v1 scope). Shared by _buildCartItems (the AJAX /cart/add path) and
  // _buildAdditionalItems (the accelerated-checkout path) so the two can never diverge on shape.
  W._buildAddOnItems = function () {
    var self = this;
    return Object.keys(this.state.selectedAddOns).map(function (key) {
      var sel = self.state.selectedAddOns[key];
      return {
        id: extractNumericId(sel.variantId),
        quantity: sel.quantity,
        properties: { _revenue_model: 'purchase', _addon: '1' },
      };
    });
  };

  // The insurance line for the active tab, or null when none is offered/selected. A paid one-off
  // line, same shape as an add-on line, but sourced from the active tab's fetched insurance detail
  // rather than the shared add-ons list. this._loadedInsurance only ever has an entry for
  // 'subscription'/'rental' (never 'purchase', see _insuranceIdForTab), so this is naturally a
  // no-op on the Buy tab. No selling_plan: the insurance premium is always a one-off purchase,
  // even when added alongside a subscription or rental main line. Shared by _buildCartItems and
  // _buildAdditionalItems.
  W._buildInsuranceItem = function () {
    var insurance = this._loadedInsurance[this.state.currentTab];
    if (!insurance || !this.state.insuranceSelected[this.state.currentTab]) return null;
    // Stamp the insured main line so ingestion can attribute this premium to the specific
    // order item (subscription / rental) it covers, not just the whole contract. Insurance is
    // only offered on the subscription and rental tabs, so the model is always one of these.
    var insuredRevenueModel = this.state.currentTab === 'rental' ? 'calendar-rental' : 'subscription';
    return {
      id: extractNumericId(insurance.insuranceVariantInternalId),
      quantity: 1,
      properties: {
        _revenue_model: 'purchase',
        _insurance: '1',
        _insured_variant: extractNumericId(this.variant.id),
        _insured_revenue_model: insuredRevenueModel,
      },
    };
  };

  // The deposit line for the active tab, or null when none is required (also null on the Buy
  // tab, which never has a deposit id - see _depositIdForTab). Unlike _buildInsuranceItem there
  // is no "selected" guard: a deposit has no opt-out, so the line is present whenever the tab's
  // deposit detail has loaded. By the time any cart build actually runs, ATC has already been
  // blocked (see _depositGateSatisfied) while a configured deposit's detail was still loading,
  // so a configured deposit is always present here. Shared by _buildCartItems and
  // _buildAdditionalItems.
  W._buildDepositItem = function () {
    var tab = this.state.currentTab;
    var deposit = this._loadedDeposit[tab];
    if (!deposit) return null; // no deposit configured for this tab (or Buy tab)
    var depositRevenueModel = tab === 'rental' ? 'calendar-rental' : 'subscription';
    return {
      id: extractNumericId(deposit.depositVariantInternalId),
      quantity: 1,
      properties: {
        _revenue_model: 'purchase',
        _deposit: '1',
        _deposit_variant: extractNumericId(this.variant.id),
        _deposit_revenue_model: depositRevenueModel,
      },
    };
  };

  // The $0 membership-mandate line, or null when it isn't required. Mirrors the checkout
  // validation function's composition rule (see membership-checkout-validation): the mandate is
  // required exactly when the main line is a Total-Commerce-managed selling-plan line (a
  // subscription with a selected plan, or a rental with a prepared plan). On the AJAX /cart/add
  // path this line is reconciled by tc-membership-embed.js after the add, so _buildCartItems
  // deliberately omits it; this builder exists only for the accelerated path (see
  // _buildAdditionalItems), where no /cart mutation happens for the embed to observe, so the
  // mandate must ride along in the same submission. Matching in both the embed and the validation
  // is by membership variant id OR selling-plan id, so the line is recognised even if the
  // properties don't attach.
  W._buildMembershipItem = function () {
    var m = this._membershipConfig;
    if (!m || m.enabled !== true || !m.variantId || !m.sellingPlanId) return null;

    var mainIsTcPlanLine =
      (this.state.currentTab === 'subscription' && !!this.state.selectedPlanId) ||
      (this.state.currentTab === 'rental' && !!this.state.preparedPlan);
    if (!mainIsTcPlanLine) return null;

    var props = {};
    props[m.revenueModelKey || '_revenueModel'] = m.revenueModelValue || 'membership';
    return {
      id: extractNumericId(m.variantId),
      quantity: 1,
      selling_plan: extractNumericId(m.sellingPlanId),
      properties: props,
    };
  };

  // The full set of companion lines an accelerated (wallet) checkout must carry alongside the
  // main product line: every selected add-on, the insurance line (if any), the required deposit
  // line (if any), and the membership mandate (if required). The main line itself is the theme
  // form's own variant + selling_plan + revenue-model, injected separately by
  // _syncSellingPlanToForm. Unlike insurance the deposit line needs no selection toggle to stay
  // current - it is simply present whenever _buildDepositItem resolves one - but this builder
  // must still be (re)invoked on every relevant state change (see _syncAdditionalItemsToForm's
  // call sites, including _renderDepositNotice's own fetch resolution) so a deposit line that
  // loads after the initial render still reaches the hidden shopify-additional-items inputs an
  // express checkout reads at submit time.
  W._buildAdditionalItems = function () {
    var items = this._buildAddOnItems();
    var insuranceItem = this._buildInsuranceItem();
    if (insuranceItem) items.push(insuranceItem);
    var depositItem = this._buildDepositItem();
    if (depositItem) items.push(depositItem);
    var membershipItem = this._buildMembershipItem();
    if (membershipItem) items.push(membershipItem);
    return items;
  };

  // POSTs the multi-line add and navigates to /cart on success. Returns a promise resolving to
  // whether the add succeeded, so callers can restore their own tab-specific button/error state
  // without this helper knowing about rental vs buy/subscribe UI.
  W._addMultiLineToCart = function () {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: this._buildCartItems() }),
    })
      .then(function (r) {
        if (r.ok) {
          window.location.href = '/cart';
          return true;
        }
        return r.json().then(function (data) {
          console.error('[Total Commerce] Add to cart failed:', data);
          return false;
        });
      })
      .catch(function (e) {
        console.error('[Total Commerce] Add to cart failed:', e);
        return false;
      });
  };

  // Fire-and-forget POST to clean up a prefetched selling plan that's no longer
  // needed (e.g. customer changed dates, switched variants, or the prefetch
  // result arrived after we'd already invalidated it). Backend marks the row
  // Abandoned and deletes the Shopify plan. Failure is non-fatal — the nightly
  // cleanup sweep is the safety net.
  W._abandonRentalPlan = function (plan) {
    if (!plan || !plan.sellingPlanInternalId) return;
    if (!this.config.apiBaseUrl || !this.config.clientId) return;

    var url = this.config.apiBaseUrl + '/selling-plan/' + encodeURIComponent(this.config.clientId) + '/calendar-rental/abandon?api-version=1';

    // keepalive allows the request to complete even if the user navigates away
    // (e.g. picks new dates then immediately clicks Rent — we still want the
    // abandon for the old dates to land).
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sellingPlanInternalId: plan.sellingPlanInternalId }),
      keepalive: true,
    }).catch(function (e) {
      console.warn('[Total Commerce] Abandon plan failed (relying on nightly cleanup):', e);
    });
  };

  // Formats an amount that's already in major units (e.g. £42.50 → "£42.50").
  // _fmt is for Shopify variant prices which arrive in minor units.
  W._fmtAmount = function (major) {
    return new Intl.NumberFormat(this.config.shopLocale || 'en-GB', {
      style: 'currency',
      currency: this.config.shopCurrency || 'GBP',
    }).format(major);
  };

  W._calcRentalTotal = function () {
    var dates = this.state.rentalDates;
    var c = this.state.rentalConstraints;
    if (!dates.start || !dates.end || !c) return null;
    var days = daysBetween(dates.start, dates.end) + 1;
    return { days: days, total: c.fixedCosts + c.dayRate * days };
  };

  W._updateRentalPricing = function () {
    var calc = this._calcRentalTotal();
    if (!calc) {
      if (this.refs.rentalBreakdown) this.refs.rentalBreakdown.style.display = 'none';
      return;
    }
    if (this.refs.rentalBreakdown) this.refs.rentalBreakdown.style.display = '';
    if (this.refs.rentalPeriod) this.refs.rentalPeriod.textContent = calc.days + ' day' + (calc.days !== 1 ? 's' : '');
    if (this.refs.rentalDailyRate) this.refs.rentalDailyRate.textContent = this._fmtAmount(calc.total / calc.days) + '/day';
    if (this.refs.rentalTotal) this.refs.rentalTotal.textContent = this._fmtAmount(calc.total);
  };

  W._updateRentalButtonState = function () {
    if (!this.refs.rentalAtcBtn) return;
    var dates = this.state.rentalDates;
    var hasDates = !!(dates.start && dates.end);

    if (this.state.rentalRequestInFlight) {
      this.refs.rentalAtcBtn.disabled = true;
      this.refs.rentalAtcBtn.textContent = 'Adding to cart…';
      return;
    }

    // Fold the T&C gate (and, Task 14, the required-deposit gate) into the existing
    // enable/disable logic rather than a second competing method. Only consult the gate when
    // the rental tab is actually the active one - _isGatePassed() reads state.currentTab, so
    // evaluating it while some other tab is active would check the wrong tab's acceptance/
    // deposit and (harmlessly, since the rental button is hidden then, but confusingly) disable
    // a button no one can see.
    var gateBlocked = this.state.currentTab === 'rental' && !this._isGatePassed();

    this.refs.rentalAtcBtn.disabled = !hasDates || gateBlocked;
    if (!hasDates) {
      this.refs.rentalAtcBtn.textContent = 'Select dates to rent';
      return;
    }
    var calc = this._calcRentalTotal();
    this.refs.rentalAtcBtn.textContent = calc ? 'Rent for ' + this._fmtAmount(calc.total) : 'Rent';
  };

  /* — Rental: ATC — */

  W._handleRentalAdd = function () {
    var self = this;
    var dates = this.state.rentalDates;
    if (!dates.start || !dates.end || !this.variant || !this.variant.wuvaVariantId || !this.config.clientId || !this.config.apiBaseUrl) return;

    var key = rentalDatesKey(dates.start, dates.end);

    // Cache hit — go immediately. This is the happy path: dates picked early
    // enough that the background prefetch already completed.
    if (this.state.preparedPlan && this.state.preparedPlan.key === key) {
      this._completeRentalAdd(this.state.preparedPlan);
      return;
    }

    // Prefetch already in flight for these exact dates — show feedback, then the
    // .then() inside _prepareRentalPlan will navigate on completion. Set a safety
    // timeout so a stuck prefetch surfaces a UI error instead of hanging.
    this.state.rentalRequestInFlight = true;
    this._updateRentalButtonState();

    if (this.state.preparingPlanKey !== key) {
      // Cache miss + no matching prefetch in flight (e.g. previous prep failed
      // silently). Kick a fresh one off.
      this._prepareRentalPlan();
    }

    setTimeout(function () {
      if (!self.state.rentalRequestInFlight) return;
      // If we reach here the prefetch hasn't completed in 10s — release the spinner
      // and let the user retry.
      self.state.rentalRequestInFlight = false;
      self._showError('Rental request timed out. Please try again.');
      self._updateRentalButtonState();
    }, 10000);
  };

  W._showError = function (msg) {
    if (!this.refs.error) return;
    this.refs.error.textContent = msg;
    this.refs.error.dataset.visible = 'true';
    var self = this;
    setTimeout(function () { if (self.refs.error) self.refs.error.dataset.visible = 'false'; }, 5000);
  };

  /* — Tabs — */

  W._switchTab = function (tab) {
    this.state.currentTab = tab;
    this.container.querySelectorAll('.tc-tab-btn').forEach(function (btn) {
      btn.setAttribute('aria-selected', btn.dataset.tab === tab ? 'true' : 'false');
    });
    this.container.querySelectorAll('.tc-panel').forEach(function (p) {
      p.dataset.active = p.dataset.panel === tab ? 'true' : 'false';
    });
    this._syncSellingPlanToForm();
    // The active tab decides which companion lines an express (wallet) purchase must carry - the
    // membership mandate rides subscription/rental main lines only - so re-sync now that the tab
    // has changed. (The wallet button's visibility is reconciled by _updateGateState below.)
    this._syncAdditionalItemsToForm();
    // Panels are built once (see _render) and never re-rendered on tab switch, but the T&C
    // gate is tab-dependent (_activeTermsId reads state.currentTab), so refresh both panels'
    // gates now that the tab has actually changed.
    this._refreshTermsGates();
    // Same tab-scoping reasoning as _refreshTermsGates, for the (non-gating) insurance checkbox.
    this._refreshInsuranceGates();
    // Same reasoning again for the mandatory deposit notice - each panel's own row must reflect
    // ITS OWN tab, and re-rendering re-fetches (or clears) this._loadedDeposit[tab] so the
    // required-deposit gate below evaluates against current data, not a stale prior tab's.
    this._refreshDepositNotices();
    // Same tab-scoping reasoning again for the merchant-configured custom fields.
    this._refreshCustomFields();
    // Reconcile Add-to-Cart gating for the newly-active tab (e.g. leaving subscribe must
    // restore any theme button we disabled; entering it while unaccepted must disable it).
    this._updateGateState();
    this._moveAddOnsSectionToActivePanel();
    if (tab === 'rental' && !this.state.rentalConstraints) {
      this._fetchRentalConstraints();
    }
  };

  W._updateTabCount = function () {
    if (!this.refs.tabNav) return;
    var visible = Array.from(this.refs.tabNav.querySelectorAll('.tc-tab-btn'))
      .filter(function (b) { return b.style.display !== 'none'; });
    this.refs.tabNav.dataset.count = String(visible.length);
  };

  /* — Plan selection — */

  W._selectPlan = function (planId) {
    this.state.selectedPlanId = planId;
    this.container.querySelectorAll('.tc-plan-btn').forEach(function (btn) {
      btn.setAttribute('aria-checked', btn.dataset.planId == planId ? 'true' : 'false');
    });
    this._updateSubscriptionSummary();
    this._syncSellingPlanToForm();
    // A selected plan is what makes the subscription main line a TC selling-plan line, so the
    // membership mandate that must accompany an express purchase depends on it - re-sync.
    this._syncAdditionalItemsToForm();
  };

  /* Subscription: billing details (interval + minimum cycles) */

  // Formats the billing-frequency value, e.g. "Every month" or "Every 3 months". Only monthly
  // intervals exist today (see MapInterval on the backend), so the unit is always months; the
  // count (billingInterval) is what varies.
  function formatBillingInterval(intervalCount) {
    var n = intervalCount || 1;
    return n === 1 ? 'Every month' : 'Every ' + n + ' months';
  }

  // Formats the minimum term as a duration, e.g. "12 months". The minimum commitment is
  // minimumBillingIntervals billing cycles, each intervalCount months long, so the term in months
  // is their product.
  function formatMinimumTerm(minCycles, intervalCount) {
    var months = minCycles * (intervalCount || 1);
    return months === 1 ? '1 month' : months + ' months';
  }

  // Populates the summary card from the currently-selected plan. The per-cycle price always comes
  // from Liquid. Minimum term and billing frequency come from the fetched API details; until those load
  // (or if the fetch failed) we fall back to the plan's free-text name for the term and hide the
  // billing-frequency row rather than show a placeholder dash.
  W._updateSubscriptionSummary = function () {
    var planId = this.state.selectedPlanId;
    if (planId == null) return;

    var plan = this._allPlans().find(function (p) { return p.id == planId; });
    var pp = this.planPrices[planId];
    var details = this.state.sellingPlanDetails[extractNumericId(planId)];
    var hasDetails = !!(details && details.minimumBillingIntervals >= 1 && details.billingInterval >= 1);

    if (this.refs.summaryPrice && pp !== undefined) {
      this.refs.summaryPrice.textContent = this._fmt(pp) + '/mo';
    }

    if (this.refs.summaryTerm) {
      if (hasDetails) {
        this.refs.summaryTerm.textContent = formatMinimumTerm(details.minimumBillingIntervals, details.billingInterval);
      } else if (plan) {
        this.refs.summaryTerm.textContent = plan.name;
      }
    }

    if (this.refs.summaryBillingRow) {
      if (hasDetails) {
        this.refs.summaryBillingRow.style.display = '';
        if (this.refs.summaryBilling) this.refs.summaryBilling.textContent = formatBillingInterval(details.billingInterval);
      } else {
        this.refs.summaryBillingRow.style.display = 'none';
      }
    }
  };

  // Builds the per-plan billing details map (billing interval + minimum cycles) for a variant,
  // keyed by numeric Shopify selling plan id so it matches the Liquid-provided plan ids. The data
  // comes from the totalcommerce.subscription_plans variant metafield, serialised into the Liquid
  // config as variant.subscriptionPlans. Returns an empty map when the metafield is absent (the
  // summary then falls back to the plan name and hides the billing-frequency row).
  W._indexVariantSellingPlanDetails = function (variant) {
    var map = {};
    var plans = variant && variant.subscriptionPlans;
    if (!Array.isArray(plans)) return map;
    plans.forEach(function (p) {
      if (!p || p.id == null) return;
      map[extractNumericId(p.id)] = p;
    });
    return map;
  };

  /* — Form integration (cross-theme) — */

  W._getProductForm = function () {
    // Horizon theme
    var form = document.querySelector(
      'product-form-component[data-section-id="' + this.sectionId + '"][data-product-id="' + this.config.productId + '"]'
    ) || document.querySelector(
      'product-form-component[data-product-id="' + this.config.productId + '"]'
    );
    if (form) return form;

    // Dawn / generic themes
    var section = this.container.closest('.shopify-section');
    if (section) {
      form = section.querySelector('product-form') || section.querySelector('form[action*="/cart/add"]');
    }
    return form || document.querySelector('product-form') || document.querySelector('form[action*="/cart/add"]');
  };

  W._syncSellingPlanToForm = function () {
    var form = this._getGateForm();
    if (!form) return;

    // Selling plan
    var existingSP = form.querySelector('input[name="selling_plan"]');
    if (this.state.currentTab === 'subscription' && this.state.selectedPlanId) {
      if (existingSP) { existingSP.value = this.state.selectedPlanId; }
      else {
        var input = document.createElement('input');
        input.type = 'hidden'; input.name = 'selling_plan'; input.value = this.state.selectedPlanId;
        form.appendChild(input);
      }
    } else {
      if (existingSP) existingSP.remove();
    }

    // Revenue model
    var rmName = 'properties[_revenue_model]';
    var existingRM = form.querySelector('input[name="' + rmName + '"]');
    var model = this._getRevenueModel();
    if (existingRM) { existingRM.value = model; }
    else {
      var rmInput = document.createElement('input');
      rmInput.type = 'hidden'; rmInput.name = rmName; rmInput.value = model;
      form.appendChild(rmInput);
    }
  };

  // Reads the membership-mandate config from the #tc-membership-config data element that the
  // "Membership auto-add" app embed serialises (blocks/tc-membership-embed.liquid). The element
  // is inert JSON present in the DOM whenever the embed is enabled, independent of whether
  // tc-membership-embed.js has executed, so this is safe to call synchronously at construction.
  // Returns null when memberships are off (no element / disabled), which suppresses all mandate
  // injection. Normalises `membership` (Liquid emits it as a JSON string-or-object, matching the
  // embed's own readConfig) and lifts the revenue-model key/value used to stamp the mandate line.
  W._readMembershipConfig = function () {
    var elem = document.getElementById('tc-membership-config');
    if (!elem) return null;
    try {
      var parsed = JSON.parse(elem.textContent);
      var membership = parsed.membership;
      if (typeof membership === 'string') membership = JSON.parse(membership);
      if (!membership) return null;
      return {
        variantId: membership.variantId,
        sellingPlanId: membership.sellingPlanId,
        enabled: membership.enabled === true,
        revenueModelKey: parsed.revenueModelKey || '_revenueModel',
        revenueModelValue: parsed.revenueModelValue || 'membership',
      };
    } catch (e) {
      console.error('[Total Commerce] Membership config parse error:', e);
      return null;
    }
  };

  // Reconciles the accelerated-checkout companion lines into the theme's product form as
  // shopify-additional-items[i][...] hidden inputs. Shopify's accelerated (wallet) buttons read
  // these off the associated product form and carry them into the express checkout, so add-ons,
  // insurance and the membership mandate survive a Buy-with-Apple-Pay / Shop Pay purchase that
  // never touches the cart page (and therefore never runs the widget's own multi-line add or the
  // membership embed's reconcile). Rebuilt from scratch on every relevant state change into a
  // single owned container so it never accumulates stale inputs. Left empty on the Rent tab,
  // where the wallet button is hidden anyway (see _updateAcceleratedCheckoutVisibility) - a
  // per-customer rental plan can't be expressed as a static form field.
  //
  // Coexistence with the normal path: a normal Add-to-Cart submit that carries add-ons/insurance
  // is intercepted (_onFormSubmit preventDefault) and routed through the AJAX multi-add, so these
  // inputs are never actually posted to /cart/add on that path; /cart/add ignores unknown
  // shopify-additional-items params regardless.
  W._syncAdditionalItemsToForm = function () {
    var form = this._getGateForm();
    if (!form) return;

    var container = form.querySelector('[data-tc-additional-items]');
    if (!container) {
      container = document.createElement('div');
      container.setAttribute('data-tc-additional-items', '1');
      container.hidden = true;
      form.appendChild(container);
    }
    container.innerHTML = '';

    if (this.state.currentTab === 'rental') return;

    var items = this._buildAdditionalItems();

    items.forEach(function (item, idx) {
      // Shopify requires additional items to be indexed starting at 1.
      var base = 'shopify-additional-items[' + (idx + 1) + ']';

      function addInput(name, value) {
        if (value === null || value === undefined || value === '') return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = String(value);
        container.appendChild(input);
      }

      addInput(base + '[id]', item.id);
      addInput(base + '[quantity]', item.quantity);
      if (item.selling_plan) addInput(base + '[selling_plan]', item.selling_plan);
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          addInput(base + '[properties][' + k + ']', item.properties[k]);
        });
      }
    });
  };

  // Injects (once) the stylesheet that hides the accelerated/dynamic checkout (wallet) button
  // when TC_HIDE_ACCEL_CLASS is present on an ancestor. Targets both the Shopify-standard custom
  // elements (present in every OS 2.0 theme) and Horizon's own wrapper, so it works cross-theme.
  // A style rule (rather than an imperative hidden attribute) survives the theme re-rendering the
  // button - which it does on variant/section changes and after its JS registers the web
  // component - whereas a set attribute would be wiped on the next redraw.
  W._ensureAcceleratedHideStyle = function () {
    if (document.getElementById('tc-accel-hide-style')) return;
    var style = document.createElement('style');
    style.id = 'tc-accel-hide-style';
    style.textContent =
      '.' + TC_HIDE_ACCEL_CLASS + ' shopify-payment-button,' +
      '.' + TC_HIDE_ACCEL_CLASS + ' shopify-accelerated-checkout,' +
      '.' + TC_HIDE_ACCEL_CLASS + ' .shopify-payment-button,' +
      '.' + TC_HIDE_ACCEL_CLASS + ' .accelerated-checkout-block' +
      ' { display: none !important; }';
    document.head.appendChild(style);
  };

  // Shows/hides the accelerated (wallet) button for the current tab by toggling
  // TC_HIDE_ACCEL_CLASS on the widget's section. Two reasons to hide it:
  //   1. Rent tab: the wallet button can only submit a single static product form, and a calendar
  //      rental's selling plan is created per-customer, per-dates on demand - it can't be
  //      expressed as a static field the button would carry, so an express purchase there would
  //      silently become a full-price one-off of the base variant.
  //   2. T&C gate unaccepted: the wallet button sits outside TC_SUBMIT_SELECTOR, so the theme-
  //      button gate (_disableGatedControls) can't reach it. Hiding it while the active tab's T&C
  //      box is unticked stops an express purchase bypassing a required acceptance.
  // Every other case carries its full basket via the shopify-additional-items inputs, so the
  // button stays available. Driven from _updateGateState, which runs on init, tab switch, variant
  // change and T&C checkbox change.
  W._updateAcceleratedCheckoutVisibility = function () {
    this._ensureAcceleratedHideStyle();
    var scope = this.container.closest('.shopify-section') || this._getGateForm();
    if (!scope) return;
    // Own-button mode hides the wallet button on every tab: the widget's own Add-to-Cart is the
    // single CTA and routes through /cart, so an express purchase off the theme form would bypass
    // it. (Rental always hides it, and any tab hides it while its gate is unmet, as before.)
    var hide = this.buyButtonMode === 'own' || this.state.currentTab === 'rental' || !this._isGatePassed();
    if (hide) scope.classList.add(TC_HIDE_ACCEL_CLASS);
    else scope.classList.remove(TC_HIDE_ACCEL_CLASS);
  };

  W._getFormElement = function () {
    var formComponent = this._getProductForm();
    if (!formComponent) return null;
    // formComponent might be a custom element or a raw <form>
    return formComponent.querySelector ? (formComponent.querySelector('form') || formComponent) : formComponent;
  };

  // Cheap reflection of addOnSubmitInFlight on the toggles themselves, alongside the re-entry
  // guards in _onFormSubmit/_completeRentalAdd. Only re-enables toggles that weren't already
  // disabled for being out of stock (see _renderAddOnRow's oosDisabled marker) so a submit that
  // finishes doesn't accidentally un-disable a genuinely unavailable add-on.
  W._setAddOnSubmitDisabled = function (disabled) {
    if (!this.container) return;
    this.container.querySelectorAll('.tc-addon-checkbox').forEach(function (cb) {
      if (disabled) {
        cb.disabled = true;
      } else if (cb.dataset.oosDisabled !== 'true') {
        cb.disabled = false;
      }
    });
  };

  // Buy/Subscribe have no ATC button of their own; the theme's native product form owns that
  // button, and _syncSellingPlanToForm only ever writes hidden inputs into it. A plain form
  // submission can express exactly one cart line, so it can't carry the add-ons/insurance/deposit
  // too; with any of these present this swaps in the same AJAX multi-add the rent tab uses. With
  // none present this is a no-op and the existing single-line submission is left completely
  // untouched. hasDeposit matters even alone (Task 14): the Subscribe tab never has an insurance
  // or add-on interaction forcing this path, but a required deposit still has to reach the cart
  // as a second line, and _buildCartItems (the only place _buildDepositItem is consulted on this
  // tab) is only ever invoked via _addMultiLineToCart below - without this check a plain
  // Subscribe submission with no add-ons/insurance selected would silently omit the deposit.
  W._onFormSubmit = function (event) {
    var hasAddOns = Object.keys(this.state.selectedAddOns).length > 0;
    var hasInsurance = !!(this._loadedInsurance[this.state.currentTab] && this.state.insuranceSelected[this.state.currentTab]);
    var hasDeposit = !!this._loadedDeposit[this.state.currentTab];
    if (!hasAddOns && !hasInsurance && !hasDeposit) return;
    if (this.state.currentTab !== 'purchase' && this.state.currentTab !== 'subscription') return;
    // Re-entrancy guard: without it, the theme's own submit handler never runs (see the
    // stopPropagation below), so its own button-disable logic never fires either, and a second
    // click/submit before the first /cart/add.js resolves would fire a second POST that doubles
    // every line.
    if (this.state.addOnSubmitInFlight) return;

    var formEl = this._getFormElement();
    if (!formEl || event.target !== formEl) return;

    event.preventDefault();
    event.stopPropagation();

    this.state.addOnSubmitInFlight = true;
    this._setAddOnSubmitDisabled(true);

    var self = this;
    this._addMultiLineToCart().then(function (ok) {
      self.state.addOnSubmitInFlight = false;
      self._setAddOnSubmitDisabled(false);
      if (!ok) self._showError('Couldn’t add to cart. Please try again.');
    });
  };

  /* — Price updates — */

  W._updateAllPrices = function () {
    var self = this;
    var v = this.variant;

    if (this.refs.buyPrice) this.refs.buyPrice.textContent = this._fmt(v ? v.price : 0);

    // Compare-at price — gated by the "Show compare-at price" block setting
    if (this.refs.buyCompare) {
      if (this.config.showCompareAtPrice !== false && v && v.compareAtPrice && v.compareAtPrice > v.price) {
        this.refs.buyCompare.textContent = this._fmt(v.compareAtPrice);
        this.refs.buyCompare.style.display = '';
      } else {
        this.refs.buyCompare.style.display = 'none';
      }
    }

    var plans = this._availablePlans();
    var lowestPrice = Infinity, highestPrice = 0;
    var pp = this.planPrices;
    plans.forEach(function (p) {
      var price = pp[p.id] || 0;
      if (price < lowestPrice) lowestPrice = price;
      if (price > highestPrice) highestPrice = price;
    });

    if (this.refs.nudgeText && lowestPrice < Infinity) {
      this.refs.nudgeText.textContent = 'Or subscribe from ' + this._fmt(lowestPrice) + '/mo';
    }

    this.container.querySelectorAll('.tc-plan-btn').forEach(function (btn) {
      var pid = btn.dataset.planId;
      var price = pp[pid];
      if (price === undefined) return;

      var priceEl = btn.querySelector('.tc-plan-price');
      if (priceEl) priceEl.innerHTML = self._fmt(price) + '<span class="tc-plan-per">/mo</span>';

      var savingsEl = btn.querySelector('.tc-plan-savings');
      if (savingsEl) {
        if (price === highestPrice) savingsEl.textContent = 'Most flexible';
        else if (highestPrice > 0) {
          var pct = Math.round(((highestPrice - price) / highestPrice) * 100);
          savingsEl.textContent = pct > 0 ? 'Save ' + pct + '%' : 'Best value';
        }
      }
    });

    if (this.refs.summaryPrice && this.state.selectedPlanId) {
      var sp = pp[this.state.selectedPlanId];
      if (sp !== undefined) this.refs.summaryPrice.textContent = this._fmt(sp) + '/mo';
    }
  };

  /* — Events — */

  W._bindEvents = function () {
    var self = this;

    // Intercepts the theme's native product-form submit when add-ons are selected: only a
    // multi-line /cart/add.js call can add the main line plus each add-on, so a plain form
    // submission can't do it. A capture-phase listener on document runs before the event ever
    // reaches the form (and therefore before any submit handler the theme itself attached to
    // it), regardless of registration order or whether the form is wrapped in a custom element.
    // document itself is never torn down between widget instances, so the previous instance's
    // handler (if any) is removed first rather than left to accumulate on every re-init.
    if (activeFormSubmitHandler) {
      document.removeEventListener('submit', activeFormSubmitHandler, true);
    }
    activeFormSubmitHandler = function (e) { self._onFormSubmit(e); };
    document.addEventListener('submit', activeFormSubmitHandler, true);

    var section = this.container.closest('.shopify-section');
    if (!section) return;

    // Horizon events
    section.addEventListener('variant:update', function (e) { self._onVariantUpdate(e); });

    // Dawn / generic events
    section.addEventListener('variant:change', function (e) { self._onVariantUpdate(e); });

    if (window.ThemeEvents) {
      if (window.ThemeEvents.variantUpdate) {
        section.addEventListener(window.ThemeEvents.variantUpdate, function (e) { self._onVariantUpdate(e); });
      }
    }
  };

  W._onVariantUpdate = function (event) {
    var resource = event.detail && (event.detail.resource || event.detail.variant);
    if (!resource || !resource.id) return;

    var previousVariantId = this.variant ? this.variant.id : null;

    var newVariant = this._findVariant(resource.id);
    if (newVariant) {
      this.variant = newVariant;
      // Allow event to override price (some themes pass live price)
      if (resource.price !== undefined) this.variant.price = resource.price;
    } else {
      // Variant not in our config — build a minimal object
      this.variant = {
        id: resource.id,
        price: resource.price || 0,
        compareAtPrice: resource.compare_at_price || null,
        available: resource.available !== undefined ? resource.available : true,
        sku: resource.sku || '',
        sellingPlanAllocations: [],
        availability: null,
        wuvaVariantId: null,
      };
    }

    // Billing details are per-variant: rebuild from the new variant's metafield data before
    // re-selecting the plan so the summary reflects the new variant immediately.
    if (previousVariantId !== this.variant.id) {
      this.state.sellingPlanDetails = this._indexVariantSellingPlanDetails(this.variant);
    }

    this._recalcPlanPrices();
    if (this.state.selectedPlanId) this._selectPlan(this.state.selectedPlanId);
    this._updateAllPrices();
    this._updateSoldOut();

    // Variant changed — tear down rental state; refetch if rental tab is active.
    if (previousVariantId !== this.variant.id) {
      this.state.rentalConstraints = null;
      this._setRentalDates(null, null);
      if (this.state.calendarInstance) {
        this.state.calendarInstance.destroy();
        this.state.calendarInstance = null;
      }
    }

    this._refreshTabVisibility();

    // A variant swap can change which (if any) T&C set gates the current tab even when the
    // tab itself doesn't change (_refreshTabVisibility only re-switches tabs when the current
    // one becomes unavailable), so refresh explicitly to keep the checkbox/label correct.
    this._refreshTermsGates();
    // Same reasoning for the insurance checkbox: the new variant may offer a different (or no)
    // insurance profile for the current tab.
    this._refreshInsuranceGates();
    // Same reasoning again for the mandatory deposit notice: the new variant may offer a
    // different (or no) deposit profile for the current tab, and _renderDepositNotice's own
    // fetch re-evaluates the required-deposit gate once it resolves.
    this._refreshDepositNotices();
    // The new variant may carry different custom fields for the active tab; re-render them (kept
    // answers survive via state.customFieldValues, keyed by label).
    this._refreshCustomFields();

    // The variant swap above can flip whether the active tab requires terms (or a deposit) at
    // all (e.g. a variant with no calendarRentalTermsId / calendarRentalDepositProfileId), so
    // re-reconcile Add-to-Cart gating explicitly rather than relying on _switchTab, which only
    // runs when the tab itself changes.
    this._updateGateState();

    // The new variant changes the insured-variant stamp on the insurance line, so re-sync the
    // accelerated-checkout companion lines. (_updateGateState above already reconciled the wallet
    // button's visibility for any tab flip.)
    this._syncAdditionalItemsToForm();

    if (this.state.currentTab === 'rental' && !this.state.rentalConstraints && this._canRent()) {
      this._fetchRentalConstraints();
    }

    this._logAvailability('variant-change');
  };

  /* === Init === */

  function init() {
    document.querySelectorAll('.tc-widget[data-section-id]').forEach(function (container) {
      var sectionId = container.dataset.sectionId;
      if (sectionId && !container.dataset.tcInit) {
        container.dataset.tcInit = 'true';
        new TCWidget(sectionId);
      }
    });
  }

  // Initial load
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-init when section is added/reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    section.querySelectorAll('.tc-widget[data-section-id]').forEach(function (container) {
      container.removeAttribute('data-tc-init');
    });
    init();
  });
})();